/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as OrgRouteImport } from './routes/$org'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MfaSetupRouteImport } from './routes/mfa-setup'
import { Route as MfaVerifyRouteImport } from './routes/mfa-verify'
import { Route as NoOrganizationRouteImport } from './routes/no-organization'
import { Route as OrganizationsRouteImport } from './routes/organizations'
import { Route as OrgIndexRouteImport } from './routes/$org/index'
import { Route as OrgActivityRouteImport } from './routes/$org/activity'
import { Route as OrgAssetsRouteImport } from './routes/$org/assets'
import { Route as OrgBenchmarkRouteImport } from './routes/$org/benchmark'
import { Route as OrgBusinessRulesRouteImport } from './routes/$org/business-rules'
import { Route as OrgConversationsRouteImport } from './routes/$org/conversations'
import { Route as OrgCreateBuildingRouteImport } from './routes/$org/createBuilding'
import { Route as OrgCreateBuildingGroupRouteImport } from './routes/$org/createBuildingGroup'
import { Route as OrgDataProtectionRouteImport } from './routes/$org/data-protection'
import { Route as OrgDebugRouteImport } from './routes/$org/debug'
import { Route as OrgDesignReferenceRouteImport } from './routes/$org/design-reference'
import { Route as OrgDocumentTypesRouteImport } from './routes/$org/document-types'
import { Route as OrgDocumentsRouteImport } from './routes/$org/documents'
import { Route as OrgGraphRouteImport } from './routes/$org/graph'
import { Route as OrgGroupRouteImport } from './routes/$org/group'
import { Route as OrgJobsRouteImport } from './routes/$org/jobs'
import { Route as OrgKnowledgeRouteImport } from './routes/$org/knowledge'
import { Route as OrgLoginRouteImport } from './routes/$org/login'
import { Route as OrgPasswordResetRouteImport } from './routes/$org/password-reset'
import { Route as OrgPatternsRouteImport } from './routes/$org/patterns'
import { Route as OrgPlanRenderingRouteImport } from './routes/$org/plan-rendering'
import { Route as OrgReportsRouteImport } from './routes/$org/reports'
import { Route as OrgSearchRouteImport } from './routes/$org/search'
import { Route as OrgSettingsRouteImport } from './routes/$org/settings'
import { Route as OrgSignInLinkRouteImport } from './routes/$org/sign-in-link'
import { Route as OrgSteeringRouteImport } from './routes/$org/steering'
import { Route as OrgTestCrashRouteImport } from './routes/$org/test-crash'
import { Route as OrgUserRouteImport } from './routes/$org/user'
import { Route as AboutIndexRouteImport } from './routes/about.index'
import { Route as AboutSlugRouteImport } from './routes/about.$slug'
import { Route as AdminProposedRulesRouteImport } from './routes/admin/proposed-rules'
import { Route as AdminRentIndicesRouteImport } from './routes/admin/rent-indices'
import { Route as ImpersonateTokenRouteImport } from './routes/impersonate.$token'
import { Route as InvitationsTokenRouteImport } from './routes/invitations.$token'
import { Route as OrganizationsIndexRouteImport } from './routes/organizations/index'
import { Route as OrganizationsOrgCodeRouteImport } from './routes/organizations/$orgCode'
import { Route as QCodeRouteImport } from './routes/q.$code'
import { Route as SOrgCodeRouteImport } from './routes/s.$orgCode'
import { Route as TestSearcheableSelectRouteImport } from './routes/test/searcheable-select'
import { Route as VOrgCodeRouteImport } from './routes/v.$orgCode'
import { Route as OrgAgentRunsIndexRouteImport } from './routes/$org/agent-runs/index'
import { Route as OrgAgentRunsRunUidRouteImport } from './routes/$org/agent-runs/$runUid'
import { Route as OrgAggregationsIndexRouteImport } from './routes/$org/aggregations/index'
import { Route as OrgAggregationsUidRouteImport } from './routes/$org/aggregations/$uid'
import { Route as OrgAssembliesIndexRouteImport } from './routes/$org/assemblies/index'
import { Route as OrgAssembliesUidRouteImport } from './routes/$org/assemblies/$uid'
import { Route as OrgAssetTypesIndexRouteImport } from './routes/$org/asset-types/index'
import { Route as OrgAssetTypesAssetTypeUidRouteImport } from './routes/$org/asset-types/$assetTypeUid'
import { Route as OrgAssetsIndexRouteImport } from './routes/$org/assets/index'
import { Route as OrgAssetsAssetUidRouteImport } from './routes/$org/assets/$assetUid'
import { Route as OrgAssetsAllRouteImport } from './routes/$org/assets/all'
import { Route as OrgAssetsCreateBasicRouteImport } from './routes/$org/assets/createBasic'
import { Route as OrgAssetsOldRouteImport } from './routes/$org/assets/old'
import { Route as OrgCampaignsIndexRouteImport } from './routes/$org/campaigns/index'
import { Route as OrgCampaignsNewRouteImport } from './routes/$org/campaigns/new'
import { Route as OrgCapexPlansIndexRouteImport } from './routes/$org/capex-plans/index'
import { Route as OrgCapexPlansPlanUidRouteImport } from './routes/$org/capex-plans/$planUid'
import { Route as OrgComplianceControlsIndexRouteImport } from './routes/$org/compliance-controls/index'
import { Route as OrgComplianceControlsControlUidRouteImport } from './routes/$org/compliance-controls/$controlUid'
import { Route as OrgComplianceControlsCreateRouteImport } from './routes/$org/compliance-controls/create'
import { Route as OrgComplianceRulesIndexRouteImport } from './routes/$org/compliance-rules/index'
import { Route as OrgComplianceRulesRuleUidRouteImport } from './routes/$org/compliance-rules/$ruleUid'
import { Route as OrgComplianceRulesCreateRouteImport } from './routes/$org/compliance-rules/create'
import { Route as OrgContractStakeholderTypesIndexRouteImport } from './routes/$org/contract-stakeholder-types/index'
import { Route as OrgContractStakeholderTypesContractStakeholderTypeUidRouteImport } from './routes/$org/contract-stakeholder-types/$contractStakeholderTypeUid'
import { Route as OrgContractStakeholderTypesCreateRouteImport } from './routes/$org/contract-stakeholder-types/create'
import { Route as OrgContractTypesIndexRouteImport } from './routes/$org/contract-types/index'
import { Route as OrgContractTypesContractTypeUidRouteImport } from './routes/$org/contract-types/$contractTypeUid'
import { Route as OrgContractTypesCreateRouteImport } from './routes/$org/contract-types/create'
import { Route as OrgContractsIndexRouteImport } from './routes/$org/contracts/index'
import { Route as OrgContractsContractUidRouteImport } from './routes/$org/contracts/$contractUid'
import { Route as OrgContractsCreateRouteImport } from './routes/$org/contracts/create'
import { Route as OrgContractsTimelineRouteImport } from './routes/$org/contracts/timeline'
import { Route as OrgConversationsIntakeAddressesRouteImport } from './routes/$org/conversations_.intake-addresses'
import { Route as OrgDataIndexRouteImport } from './routes/$org/data/index'
import { Route as OrgDataExportRouteImport } from './routes/$org/data/export'
import { Route as OrgDataImportRouteImport } from './routes/$org/data/import'
import { Route as OrgDataQualityRouteImport } from './routes/$org/data/quality'
import { Route as OrgDebugAnnotationsRouteImport } from './routes/$org/debug_.annotations'
import { Route as OrgDerivationsIndexRouteImport } from './routes/$org/derivations/index'
import { Route as OrgDerivationsUidRouteImport } from './routes/$org/derivations/$uid'
import { Route as OrgDocumentsIndexRouteImport } from './routes/$org/documents/index'
import { Route as OrgDocumentsDocUidRouteImport } from './routes/$org/documents/$docUid'
import { Route as OrgExpensesIndexRouteImport } from './routes/$org/expenses/index'
import { Route as OrgExpensesExpenseUidRouteImport } from './routes/$org/expenses/$expenseUid'
import { Route as OrgExpensesStatementRouteImport } from './routes/$org/expenses/statement'
import { Route as OrgFolderLayoutsIndexRouteImport } from './routes/$org/folder-layouts/index'
import { Route as OrgFolderLayoutsLayoutUidRouteImport } from './routes/$org/folder-layouts/$layoutUid'
import { Route as OrgGroupIndexRouteImport } from './routes/$org/group/index'
import { Route as OrgGroupAccessRouteImport } from './routes/$org/group/access'
import { Route as OrgGroupCriteriaRouteImport } from './routes/$org/group/criteria'
import { Route as OrgGroupDefinitionsRouteImport } from './routes/$org/group/definitions'
import { Route as OrgGroupGovernanceRouteImport } from './routes/$org/group/governance'
import { Route as OrgGroupPerimetersRouteImport } from './routes/$org/group/perimeters'
import { Route as OrgGroupSitesRouteImport } from './routes/$org/group/sites'
import { Route as OrgImportsIndexRouteImport } from './routes/$org/imports/index'
import { Route as OrgImportsImportUidRouteImport } from './routes/$org/imports/$importUid'
import { Route as OrgInterventionsIndexRouteImport } from './routes/$org/interventions/index'
import { Route as OrgInterventionsInterventionUidRouteImport } from './routes/$org/interventions/$interventionUid'
import { Route as OrgIssuesIndexRouteImport } from './routes/$org/issues/index'
import { Route as OrgIssuesUidRouteImport } from './routes/$org/issues/$uid'
import { Route as OrgJobsIndexRouteImport } from './routes/$org/jobs/index'
import { Route as OrgJobsJobUidRouteImport } from './routes/$org/jobs/$jobUid'
import { Route as OrgJobsBlockersRouteImport } from './routes/$org/jobs/blockers'
import { Route as OrgLabelsCodeRouteImport } from './routes/$org/labels.$code'
import { Route as OrgLeasesIndexRouteImport } from './routes/$org/leases/index'
import { Route as OrgListingsIndexRouteImport } from './routes/$org/listings/index'
import { Route as OrgListingsListingUidRouteImport } from './routes/$org/listings/$listingUid'
import { Route as OrgNormalizationsIndexRouteImport } from './routes/$org/normalizations/index'
import { Route as OrgNormalizationsUidRouteImport } from './routes/$org/normalizations/$uid'
import { Route as OrgPropertiesIndexRouteImport } from './routes/$org/properties/index'
import { Route as OrgPropertiesCreateRouteImport } from './routes/$org/properties/create'
import { Route as OrgPropertyMappingRulesIndexRouteImport } from './routes/$org/property-mapping-rules/index'
import { Route as OrgPropertyMappingRulesUidRouteImport } from './routes/$org/property-mapping-rules/$uid'
import { Route as OrgRelationTypesIndexRouteImport } from './routes/$org/relation-types/index'
import { Route as OrgRelationTypesRelationTypeUidRouteImport } from './routes/$org/relation-types/$relationTypeUid'
import { Route as OrgRelationTypesCreateRouteImport } from './routes/$org/relation-types/create'
import { Route as OrgRemediationScenariosIndexRouteImport } from './routes/$org/remediation-scenarios/index'
import { Route as OrgRemediationScenariosCodeRouteImport } from './routes/$org/remediation-scenarios/$code'
import { Route as OrgRentalApplicationsIndexRouteImport } from './routes/$org/rental-applications/index'
import { Route as OrgRentalApplicationsApplicationUidRouteImport } from './routes/$org/rental-applications/$applicationUid'
import { Route as OrgRentalApplicationsViewingsRouteImport } from './routes/$org/rental-applications/viewings'
import { Route as OrgSettingsAiModelsRouteImport } from './routes/$org/settings/ai-models'
import { Route as OrgSettingsArchiveRouteImport } from './routes/$org/settings/archive'
import { Route as OrgSignaturesIndexRouteImport } from './routes/$org/signatures/index'
import { Route as OrgSignaturesUidRouteImport } from './routes/$org/signatures/$uid'
import { Route as OrgTagsIndexRouteImport } from './routes/$org/tags/index'
import { Route as OrgTagsTagCodeRouteImport } from './routes/$org/tags/$tagCode'
import { Route as OrgTypesIndexRouteImport } from './routes/$org/types/index'
import { Route as OrgTypesDefaultsRouteImport } from './routes/$org/types/defaults'
import { Route as OrgTypesExportRouteImport } from './routes/$org/types/export'
import { Route as OrgTypesImportRouteImport } from './routes/$org/types/import'
import { Route as OrgUserMeRouteImport } from './routes/$org/user/me'
import { Route as OrgUsersIndexRouteImport } from './routes/$org/users/index'
import { Route as OrgUsersCreateRouteImport } from './routes/$org/users/create'
import { Route as OrgUsersMeRouteImport } from './routes/$org/users/me'
import { Route as AdminAgentPoolIndexRouteImport } from './routes/admin/agent-pool/index'
import { Route as AdminBillingIndexRouteImport } from './routes/admin/billing/index'
import { Route as AdminBillingOrgUidRouteImport } from './routes/admin/billing/$orgUid'
import { Route as AdminBillingPricesRouteImport } from './routes/admin/billing/prices'
import { Route as AdminBillingSimulatorRouteImport } from './routes/admin/billing/simulator'
import { Route as AdminOrganizationsIndexRouteImport } from './routes/admin/organizations/index'
import { Route as AdminSettingsIndexRouteImport } from './routes/admin/settings/index'
import { Route as AdminUsageIndexRouteImport } from './routes/admin/usage/index'
import { Route as COrgCodeTokenRouteImport } from './routes/c.$orgCode.$token'
import { Route as ROrgCodeAddressRouteImport } from './routes/r.$orgCode.$address'
import { Route as TestBareCrashRouteImport } from './routes/test/bare/crash'
import { Route as WoOrgCodeTokenRouteImport } from './routes/wo.$orgCode.$token'
import { Route as OrgAssembliesUidRoomRouteImport } from './routes/$org/assemblies/$uid_.room'
import { Route as OrgAssetsAssetUidEditRouteImport } from './routes/$org/assets/$assetUid/edit'
import { Route as OrgAssetsAssetUidPlanEditorRouteImport } from './routes/$org/assets/$assetUid_/plan-editor'
import { Route as OrgCampaignsCampaignUidIndexRouteImport } from './routes/$org/campaigns/$campaignUid/index'
import { Route as OrgCampaignsCampaignUidEditRouteImport } from './routes/$org/campaigns/$campaignUid/edit'
import { Route as OrgExpensesExpenseUidEditRouteImport } from './routes/$org/expenses/$expenseUid/edit'
import { Route as OrgInterventionsInterventionUidEditRouteImport } from './routes/$org/interventions/$interventionUid/edit'
import { Route as OrgIssuesUidEditRouteImport } from './routes/$org/issues/$uid/edit'
import { Route as OrgPropertiesPropertyUidIndexRouteImport } from './routes/$org/properties/$propertyUid/index'
import { Route as OrgPropertiesPropertyUidEditRouteImport } from './routes/$org/properties/$propertyUid/edit'
import { Route as OrgSettingsBillingIndexRouteImport } from './routes/$org/settings/billing/index'
import { Route as OrgSettingsFeatureFlagsIndexRouteImport } from './routes/$org/settings/feature-flags/index'
import { Route as OrgSettingsMembersIndexRouteImport } from './routes/$org/settings/members/index'
import { Route as OrgSettingsOrganizationIndexRouteImport } from './routes/$org/settings/organization/index'
import { Route as OrgSettingsRolesIndexRouteImport } from './routes/$org/settings/roles/index'
import { Route as OrgSettingsSecurityIndexRouteImport } from './routes/$org/settings/security/index'
import { Route as OrgSettingsTagsIndexRouteImport } from './routes/$org/settings/tags/index'
import { Route as OrgSettingsTagsTagIdRouteImport } from './routes/$org/settings/tags/$tagId'
import { Route as OrgSettingsWebhooksIndexRouteImport } from './routes/$org/settings/webhooks/index'
import { Route as OrgSettingsWebhooksSubscriptionUidRouteImport } from './routes/$org/settings/webhooks/$subscriptionUid'
import { Route as OrgTypesSyncIndexRouteImport } from './routes/$org/types/sync/index'
import { Route as OrgTypesThematicsIndexRouteImport } from './routes/$org/types/thematics/index'
import { Route as OrgTypesThematicsCodeRouteImport } from './routes/$org/types/thematics/$code'
import { Route as OrgUserMeEmailIngestionRouteImport } from './routes/$org/user/me/email-ingestion'
import { Route as OrgUserMeNotificationsRouteImport } from './routes/$org/user/me/notifications'
import { Route as OrgUserMePasskeysRouteImport } from './routes/$org/user/me/passkeys'
import { Route as OrgUserMePatRouteImport } from './routes/$org/user/me/pat'
import { Route as OrgUserMeProfileRouteImport } from './routes/$org/user/me/profile'
import { Route as OrgUserMeSecurityRouteImport } from './routes/$org/user/me/security'
import { Route as OrgUserMeSessionsRouteImport } from './routes/$org/user/me/sessions'
import { Route as OrgUsersUserUidIndexRouteImport } from './routes/$org/users/$userUid/index'
import { Route as OrgUsersUserUidSettingsRouteImport } from './routes/$org/users/$userUid/settings'
import { Route as OrgUsersUserUidTokensRouteImport } from './routes/$org/users/$userUid/tokens'
import { Route as OrgUsersMeSettingsRouteImport } from './routes/$org/users/me/settings'
import { Route as AdminBillingInvoicesIndexRouteImport } from './routes/admin/billing/invoices/index'
import { Route as AdminBillingInvoicesUidRouteImport } from './routes/admin/billing/invoices/$uid'
import { Route as UOrgCodeTokenUnsubscribeRouteImport } from './routes/u.$orgCode.$token.unsubscribe'
import { Route as OrgCampaignsCampaignUidUnitsUnitUidRouteImport } from './routes/$org/campaigns/$campaignUid/units/$unitUid'
import { Route as OrgSettingsMembersUserUidSessionsRouteImport } from './routes/$org/settings/members/$userUid/sessions'
import { Route as OrgTypesSyncRunsIndexRouteImport } from './routes/$org/types/sync/runs/index'
import { Route as OrgTypesSyncRunsRunUidRouteImport } from './routes/$org/types/sync/runs/$runUid'
import { Route as COrgCodeTokenViewingsViewingUidRouteImport } from './routes/c.$orgCode.$token_.viewings.$viewingUid'
import { Route as OrgJobsJobUidExecutionsExecutionUidIndexRouteImport } from './routes/$org/jobs/$jobUid/executions/$executionUid/index'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgRoute = OrgRouteImport.update({
  id: '/$org',
  path: '/$org',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaSetupRoute = MfaSetupRouteImport.update({
  id: '/mfa-setup',
  path: '/mfa-setup',
  getParentRoute: () => rootRouteImport,
} as any)
const MfaVerifyRoute = MfaVerifyRouteImport.update({
  id: '/mfa-verify',
  path: '/mfa-verify',
  getParentRoute: () => rootRouteImport,
} as any)
const NoOrganizationRoute = NoOrganizationRouteImport.update({
  id: '/no-organization',
  path: '/no-organization',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsRoute = OrganizationsRouteImport.update({
  id: '/organizations',
  path: '/organizations',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgIndexRoute = OrgIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgActivityRoute = OrgActivityRouteImport.update({
  id: '/activity',
  path: '/activity',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAssetsRoute = OrgAssetsRouteImport.update({
  id: '/assets',
  path: '/assets',
  getParentRoute: () => OrgRoute,
} as any)
const OrgBenchmarkRoute = OrgBenchmarkRouteImport.update({
  id: '/benchmark',
  path: '/benchmark',
  getParentRoute: () => OrgRoute,
} as any)
const OrgBusinessRulesRoute = OrgBusinessRulesRouteImport.update({
  id: '/business-rules',
  path: '/business-rules',
  getParentRoute: () => OrgRoute,
} as any)
const OrgConversationsRoute = OrgConversationsRouteImport.update({
  id: '/conversations',
  path: '/conversations',
  getParentRoute: () => OrgRoute,
} as any)
const OrgCreateBuildingRoute = OrgCreateBuildingRouteImport.update({
  id: '/createBuilding',
  path: '/createBuilding',
  getParentRoute: () => OrgRoute,
} as any)
const OrgCreateBuildingGroupRoute = OrgCreateBuildingGroupRouteImport.update({
  id: '/createBuildingGroup',
  path: '/createBuildingGroup',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDataProtectionRoute = OrgDataProtectionRouteImport.update({
  id: '/data-protection',
  path: '/data-protection',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDebugRoute = OrgDebugRouteImport.update({
  id: '/debug',
  path: '/debug',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDesignReferenceRoute = OrgDesignReferenceRouteImport.update({
  id: '/design-reference',
  path: '/design-reference',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDocumentTypesRoute = OrgDocumentTypesRouteImport.update({
  id: '/document-types',
  path: '/document-types',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDocumentsRoute = OrgDocumentsRouteImport.update({
  id: '/documents',
  path: '/documents',
  getParentRoute: () => OrgRoute,
} as any)
const OrgGraphRoute = OrgGraphRouteImport.update({
  id: '/graph',
  path: '/graph',
  getParentRoute: () => OrgRoute,
} as any)
const OrgGroupRoute = OrgGroupRouteImport.update({
  id: '/group',
  path: '/group',
  getParentRoute: () => OrgRoute,
} as any)
const OrgJobsRoute = OrgJobsRouteImport.update({
  id: '/jobs',
  path: '/jobs',
  getParentRoute: () => OrgRoute,
} as any)
const OrgKnowledgeRoute = OrgKnowledgeRouteImport.update({
  id: '/knowledge',
  path: '/knowledge',
  getParentRoute: () => OrgRoute,
} as any)
const OrgLoginRoute = OrgLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => OrgRoute,
} as any)
const OrgPasswordResetRoute = OrgPasswordResetRouteImport.update({
  id: '/password-reset',
  path: '/password-reset',
  getParentRoute: () => OrgRoute,
} as any)
const OrgPatternsRoute = OrgPatternsRouteImport.update({
  id: '/patterns',
  path: '/patterns',
  getParentRoute: () => OrgRoute,
} as any)
const OrgPlanRenderingRoute = OrgPlanRenderingRouteImport.update({
  id: '/plan-rendering',
  path: '/plan-rendering',
  getParentRoute: () => OrgRoute,
} as any)
const OrgReportsRoute = OrgReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => OrgRoute,
} as any)
const OrgSearchRoute = OrgSearchRouteImport.update({
  id: '/search',
  path: '/search',
  getParentRoute: () => OrgRoute,
} as any)
const OrgSettingsRoute = OrgSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgRoute,
} as any)
const OrgSignInLinkRoute = OrgSignInLinkRouteImport.update({
  id: '/sign-in-link',
  path: '/sign-in-link',
  getParentRoute: () => OrgRoute,
} as any)
const OrgSteeringRoute = OrgSteeringRouteImport.update({
  id: '/steering',
  path: '/steering',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTestCrashRoute = OrgTestCrashRouteImport.update({
  id: '/test-crash',
  path: '/test-crash',
  getParentRoute: () => OrgRoute,
} as any)
const OrgUserRoute = OrgUserRouteImport.update({
  id: '/user',
  path: '/user',
  getParentRoute: () => OrgRoute,
} as any)
const AboutIndexRoute = AboutIndexRouteImport.update({
  id: '/about/',
  path: '/about/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutSlugRoute = AboutSlugRouteImport.update({
  id: '/about/$slug',
  path: '/about/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminProposedRulesRoute = AdminProposedRulesRouteImport.update({
  id: '/admin/proposed-rules',
  path: '/admin/proposed-rules',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRentIndicesRoute = AdminRentIndicesRouteImport.update({
  id: '/admin/rent-indices',
  path: '/admin/rent-indices',
  getParentRoute: () => rootRouteImport,
} as any)
const ImpersonateTokenRoute = ImpersonateTokenRouteImport.update({
  id: '/impersonate/$token',
  path: '/impersonate/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const InvitationsTokenRoute = InvitationsTokenRouteImport.update({
  id: '/invitations/$token',
  path: '/invitations/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganizationsIndexRoute = OrganizationsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrganizationsRoute,
} as any)
const OrganizationsOrgCodeRoute = OrganizationsOrgCodeRouteImport.update({
  id: '/$orgCode',
  path: '/$orgCode',
  getParentRoute: () => OrganizationsRoute,
} as any)
const QCodeRoute = QCodeRouteImport.update({
  id: '/q/$code',
  path: '/q/$code',
  getParentRoute: () => rootRouteImport,
} as any)
const SOrgCodeRoute = SOrgCodeRouteImport.update({
  id: '/s/$orgCode',
  path: '/s/$orgCode',
  getParentRoute: () => rootRouteImport,
} as any)
const TestSearcheableSelectRoute = TestSearcheableSelectRouteImport.update({
  id: '/test/searcheable-select',
  path: '/test/searcheable-select',
  getParentRoute: () => rootRouteImport,
} as any)
const VOrgCodeRoute = VOrgCodeRouteImport.update({
  id: '/v/$orgCode',
  path: '/v/$orgCode',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAgentRunsIndexRoute = OrgAgentRunsIndexRouteImport.update({
  id: '/agent-runs/',
  path: '/agent-runs/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAgentRunsRunUidRoute = OrgAgentRunsRunUidRouteImport.update({
  id: '/agent-runs/$runUid',
  path: '/agent-runs/$runUid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAggregationsIndexRoute = OrgAggregationsIndexRouteImport.update({
  id: '/aggregations/',
  path: '/aggregations/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAggregationsUidRoute = OrgAggregationsUidRouteImport.update({
  id: '/aggregations/$uid',
  path: '/aggregations/$uid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAssembliesIndexRoute = OrgAssembliesIndexRouteImport.update({
  id: '/assemblies/',
  path: '/assemblies/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAssembliesUidRoute = OrgAssembliesUidRouteImport.update({
  id: '/assemblies/$uid',
  path: '/assemblies/$uid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAssetTypesIndexRoute = OrgAssetTypesIndexRouteImport.update({
  id: '/asset-types/',
  path: '/asset-types/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAssetTypesAssetTypeUidRoute =
  OrgAssetTypesAssetTypeUidRouteImport.update({
    id: '/asset-types/$assetTypeUid',
    path: '/asset-types/$assetTypeUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgAssetsIndexRoute = OrgAssetsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgAssetsRoute,
} as any)
const OrgAssetsAssetUidRoute = OrgAssetsAssetUidRouteImport.update({
  id: '/$assetUid',
  path: '/$assetUid',
  getParentRoute: () => OrgAssetsRoute,
} as any)
const OrgAssetsAllRoute = OrgAssetsAllRouteImport.update({
  id: '/all',
  path: '/all',
  getParentRoute: () => OrgAssetsRoute,
} as any)
const OrgAssetsCreateBasicRoute = OrgAssetsCreateBasicRouteImport.update({
  id: '/createBasic',
  path: '/createBasic',
  getParentRoute: () => OrgAssetsRoute,
} as any)
const OrgAssetsOldRoute = OrgAssetsOldRouteImport.update({
  id: '/old',
  path: '/old',
  getParentRoute: () => OrgAssetsRoute,
} as any)
const OrgCampaignsIndexRoute = OrgCampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgCampaignsNewRoute = OrgCampaignsNewRouteImport.update({
  id: '/campaigns/new',
  path: '/campaigns/new',
  getParentRoute: () => OrgRoute,
} as any)
const OrgCapexPlansIndexRoute = OrgCapexPlansIndexRouteImport.update({
  id: '/capex-plans/',
  path: '/capex-plans/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgCapexPlansPlanUidRoute = OrgCapexPlansPlanUidRouteImport.update({
  id: '/capex-plans/$planUid',
  path: '/capex-plans/$planUid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgComplianceControlsIndexRoute =
  OrgComplianceControlsIndexRouteImport.update({
    id: '/compliance-controls/',
    path: '/compliance-controls/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgComplianceControlsControlUidRoute =
  OrgComplianceControlsControlUidRouteImport.update({
    id: '/compliance-controls/$controlUid',
    path: '/compliance-controls/$controlUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgComplianceControlsCreateRoute =
  OrgComplianceControlsCreateRouteImport.update({
    id: '/compliance-controls/create',
    path: '/compliance-controls/create',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgComplianceRulesIndexRoute = OrgComplianceRulesIndexRouteImport.update({
  id: '/compliance-rules/',
  path: '/compliance-rules/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgComplianceRulesRuleUidRoute =
  OrgComplianceRulesRuleUidRouteImport.update({
    id: '/compliance-rules/$ruleUid',
    path: '/compliance-rules/$ruleUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgComplianceRulesCreateRoute =
  OrgComplianceRulesCreateRouteImport.update({
    id: '/compliance-rules/create',
    path: '/compliance-rules/create',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgContractStakeholderTypesIndexRoute =
  OrgContractStakeholderTypesIndexRouteImport.update({
    id: '/contract-stakeholder-types/',
    path: '/contract-stakeholder-types/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgContractStakeholderTypesContractStakeholderTypeUidRoute =
  OrgContractStakeholderTypesContractStakeholderTypeUidRouteImport.update({
    id: '/contract-stakeholder-types/$contractStakeholderTypeUid',
    path: '/contract-stakeholder-types/$contractStakeholderTypeUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgContractStakeholderTypesCreateRoute =
  OrgContractStakeholderTypesCreateRouteImport.update({
    id: '/contract-stakeholder-types/create',
    path: '/contract-stakeholder-types/create',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgContractTypesIndexRoute = OrgContractTypesIndexRouteImport.update({
  id: '/contract-types/',
  path: '/contract-types/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgContractTypesContractTypeUidRoute =
  OrgContractTypesContractTypeUidRouteImport.update({
    id: '/contract-types/$contractTypeUid',
    path: '/contract-types/$contractTypeUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgContractTypesCreateRoute = OrgContractTypesCreateRouteImport.update({
  id: '/contract-types/create',
  path: '/contract-types/create',
  getParentRoute: () => OrgRoute,
} as any)
const OrgContractsIndexRoute = OrgContractsIndexRouteImport.update({
  id: '/contracts/',
  path: '/contracts/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgContractsContractUidRoute = OrgContractsContractUidRouteImport.update({
  id: '/contracts/$contractUid',
  path: '/contracts/$contractUid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgContractsCreateRoute = OrgContractsCreateRouteImport.update({
  id: '/contracts/create',
  path: '/contracts/create',
  getParentRoute: () => OrgRoute,
} as any)
const OrgContractsTimelineRoute = OrgContractsTimelineRouteImport.update({
  id: '/contracts/timeline',
  path: '/contracts/timeline',
  getParentRoute: () => OrgRoute,
} as any)
const OrgConversationsIntakeAddressesRoute =
  OrgConversationsIntakeAddressesRouteImport.update({
    id: '/conversations_/intake-addresses',
    path: '/conversations/intake-addresses',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgDataIndexRoute = OrgDataIndexRouteImport.update({
  id: '/data/',
  path: '/data/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDataExportRoute = OrgDataExportRouteImport.update({
  id: '/data/export',
  path: '/data/export',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDataImportRoute = OrgDataImportRouteImport.update({
  id: '/data/import',
  path: '/data/import',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDataQualityRoute = OrgDataQualityRouteImport.update({
  id: '/data/quality',
  path: '/data/quality',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDebugAnnotationsRoute = OrgDebugAnnotationsRouteImport.update({
  id: '/debug_/annotations',
  path: '/debug/annotations',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDerivationsIndexRoute = OrgDerivationsIndexRouteImport.update({
  id: '/derivations/',
  path: '/derivations/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDerivationsUidRoute = OrgDerivationsUidRouteImport.update({
  id: '/derivations/$uid',
  path: '/derivations/$uid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgDocumentsIndexRoute = OrgDocumentsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgDocumentsRoute,
} as any)
const OrgDocumentsDocUidRoute = OrgDocumentsDocUidRouteImport.update({
  id: '/$docUid',
  path: '/$docUid',
  getParentRoute: () => OrgDocumentsRoute,
} as any)
const OrgExpensesIndexRoute = OrgExpensesIndexRouteImport.update({
  id: '/expenses/',
  path: '/expenses/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgExpensesExpenseUidRoute = OrgExpensesExpenseUidRouteImport.update({
  id: '/expenses/$expenseUid',
  path: '/expenses/$expenseUid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgExpensesStatementRoute = OrgExpensesStatementRouteImport.update({
  id: '/expenses/statement',
  path: '/expenses/statement',
  getParentRoute: () => OrgRoute,
} as any)
const OrgFolderLayoutsIndexRoute = OrgFolderLayoutsIndexRouteImport.update({
  id: '/folder-layouts/',
  path: '/folder-layouts/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgFolderLayoutsLayoutUidRoute =
  OrgFolderLayoutsLayoutUidRouteImport.update({
    id: '/folder-layouts/$layoutUid',
    path: '/folder-layouts/$layoutUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgGroupIndexRoute = OrgGroupIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgGroupRoute,
} as any)
const OrgGroupAccessRoute = OrgGroupAccessRouteImport.update({
  id: '/access',
  path: '/access',
  getParentRoute: () => OrgGroupRoute,
} as any)
const OrgGroupCriteriaRoute = OrgGroupCriteriaRouteImport.update({
  id: '/criteria',
  path: '/criteria',
  getParentRoute: () => OrgGroupRoute,
} as any)
const OrgGroupDefinitionsRoute = OrgGroupDefinitionsRouteImport.update({
  id: '/definitions',
  path: '/definitions',
  getParentRoute: () => OrgGroupRoute,
} as any)
const OrgGroupGovernanceRoute = OrgGroupGovernanceRouteImport.update({
  id: '/governance',
  path: '/governance',
  getParentRoute: () => OrgGroupRoute,
} as any)
const OrgGroupPerimetersRoute = OrgGroupPerimetersRouteImport.update({
  id: '/perimeters',
  path: '/perimeters',
  getParentRoute: () => OrgGroupRoute,
} as any)
const OrgGroupSitesRoute = OrgGroupSitesRouteImport.update({
  id: '/sites',
  path: '/sites',
  getParentRoute: () => OrgGroupRoute,
} as any)
const OrgImportsIndexRoute = OrgImportsIndexRouteImport.update({
  id: '/imports/',
  path: '/imports/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgImportsImportUidRoute = OrgImportsImportUidRouteImport.update({
  id: '/imports/$importUid',
  path: '/imports/$importUid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgInterventionsIndexRoute = OrgInterventionsIndexRouteImport.update({
  id: '/interventions/',
  path: '/interventions/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgInterventionsInterventionUidRoute =
  OrgInterventionsInterventionUidRouteImport.update({
    id: '/interventions/$interventionUid',
    path: '/interventions/$interventionUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgIssuesIndexRoute = OrgIssuesIndexRouteImport.update({
  id: '/issues/',
  path: '/issues/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgIssuesUidRoute = OrgIssuesUidRouteImport.update({
  id: '/issues/$uid',
  path: '/issues/$uid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgJobsIndexRoute = OrgJobsIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => OrgJobsRoute,
} as any)
const OrgJobsJobUidRoute = OrgJobsJobUidRouteImport.update({
  id: '/$jobUid',
  path: '/$jobUid',
  getParentRoute: () => OrgJobsRoute,
} as any)
const OrgJobsBlockersRoute = OrgJobsBlockersRouteImport.update({
  id: '/blockers',
  path: '/blockers',
  getParentRoute: () => OrgJobsRoute,
} as any)
const OrgLabelsCodeRoute = OrgLabelsCodeRouteImport.update({
  id: '/labels/$code',
  path: '/labels/$code',
  getParentRoute: () => OrgRoute,
} as any)
const OrgLeasesIndexRoute = OrgLeasesIndexRouteImport.update({
  id: '/leases/',
  path: '/leases/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgListingsIndexRoute = OrgListingsIndexRouteImport.update({
  id: '/listings/',
  path: '/listings/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgListingsListingUidRoute = OrgListingsListingUidRouteImport.update({
  id: '/listings/$listingUid',
  path: '/listings/$listingUid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgNormalizationsIndexRoute = OrgNormalizationsIndexRouteImport.update({
  id: '/normalizations/',
  path: '/normalizations/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgNormalizationsUidRoute = OrgNormalizationsUidRouteImport.update({
  id: '/normalizations/$uid',
  path: '/normalizations/$uid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgPropertiesIndexRoute = OrgPropertiesIndexRouteImport.update({
  id: '/properties/',
  path: '/properties/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgPropertiesCreateRoute = OrgPropertiesCreateRouteImport.update({
  id: '/properties/create',
  path: '/properties/create',
  getParentRoute: () => OrgRoute,
} as any)
const OrgPropertyMappingRulesIndexRoute =
  OrgPropertyMappingRulesIndexRouteImport.update({
    id: '/property-mapping-rules/',
    path: '/property-mapping-rules/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgPropertyMappingRulesUidRoute =
  OrgPropertyMappingRulesUidRouteImport.update({
    id: '/property-mapping-rules/$uid',
    path: '/property-mapping-rules/$uid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgRelationTypesIndexRoute = OrgRelationTypesIndexRouteImport.update({
  id: '/relation-types/',
  path: '/relation-types/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgRelationTypesRelationTypeUidRoute =
  OrgRelationTypesRelationTypeUidRouteImport.update({
    id: '/relation-types/$relationTypeUid',
    path: '/relation-types/$relationTypeUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgRelationTypesCreateRoute = OrgRelationTypesCreateRouteImport.update({
  id: '/relation-types/create',
  path: '/relation-types/create',
  getParentRoute: () => OrgRoute,
} as any)
const OrgRemediationScenariosIndexRoute =
  OrgRemediationScenariosIndexRouteImport.update({
    id: '/remediation-scenarios/',
    path: '/remediation-scenarios/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgRemediationScenariosCodeRoute =
  OrgRemediationScenariosCodeRouteImport.update({
    id: '/remediation-scenarios/$code',
    path: '/remediation-scenarios/$code',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgRentalApplicationsIndexRoute =
  OrgRentalApplicationsIndexRouteImport.update({
    id: '/rental-applications/',
    path: '/rental-applications/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgRentalApplicationsApplicationUidRoute =
  OrgRentalApplicationsApplicationUidRouteImport.update({
    id: '/rental-applications/$applicationUid',
    path: '/rental-applications/$applicationUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgRentalApplicationsViewingsRoute =
  OrgRentalApplicationsViewingsRouteImport.update({
    id: '/rental-applications/viewings',
    path: '/rental-applications/viewings',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgSettingsAiModelsRoute = OrgSettingsAiModelsRouteImport.update({
  id: '/ai-models',
  path: '/ai-models',
  getParentRoute: () => OrgSettingsRoute,
} as any)
const OrgSettingsArchiveRoute = OrgSettingsArchiveRouteImport.update({
  id: '/archive',
  path: '/archive',
  getParentRoute: () => OrgSettingsRoute,
} as any)
const OrgSignaturesIndexRoute = OrgSignaturesIndexRouteImport.update({
  id: '/signatures/',
  path: '/signatures/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgSignaturesUidRoute = OrgSignaturesUidRouteImport.update({
  id: '/signatures/$uid',
  path: '/signatures/$uid',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTagsIndexRoute = OrgTagsIndexRouteImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTagsTagCodeRoute = OrgTagsTagCodeRouteImport.update({
  id: '/tags/$tagCode',
  path: '/tags/$tagCode',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTypesIndexRoute = OrgTypesIndexRouteImport.update({
  id: '/types/',
  path: '/types/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTypesDefaultsRoute = OrgTypesDefaultsRouteImport.update({
  id: '/types/defaults',
  path: '/types/defaults',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTypesExportRoute = OrgTypesExportRouteImport.update({
  id: '/types/export',
  path: '/types/export',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTypesImportRoute = OrgTypesImportRouteImport.update({
  id: '/types/import',
  path: '/types/import',
  getParentRoute: () => OrgRoute,
} as any)
const OrgUserMeRoute = OrgUserMeRouteImport.update({
  id: '/me',
  path: '/me',
  getParentRoute: () => OrgUserRoute,
} as any)
const OrgUsersIndexRoute = OrgUsersIndexRouteImport.update({
  id: '/users/',
  path: '/users/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgUsersCreateRoute = OrgUsersCreateRouteImport.update({
  id: '/users/create',
  path: '/users/create',
  getParentRoute: () => OrgRoute,
} as any)
const OrgUsersMeRoute = OrgUsersMeRouteImport.update({
  id: '/users/me',
  path: '/users/me',
  getParentRoute: () => OrgRoute,
} as any)
const AdminAgentPoolIndexRoute = AdminAgentPoolIndexRouteImport.update({
  id: '/admin/agent-pool/',
  path: '/admin/agent-pool/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingIndexRoute = AdminBillingIndexRouteImport.update({
  id: '/admin/billing/',
  path: '/admin/billing/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingOrgUidRoute = AdminBillingOrgUidRouteImport.update({
  id: '/admin/billing/$orgUid',
  path: '/admin/billing/$orgUid',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingPricesRoute = AdminBillingPricesRouteImport.update({
  id: '/admin/billing/prices',
  path: '/admin/billing/prices',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminBillingSimulatorRoute = AdminBillingSimulatorRouteImport.update({
  id: '/admin/billing/simulator',
  path: '/admin/billing/simulator',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminOrganizationsIndexRoute = AdminOrganizationsIndexRouteImport.update({
  id: '/admin/organizations/',
  path: '/admin/organizations/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminSettingsIndexRoute = AdminSettingsIndexRouteImport.update({
  id: '/admin/settings/',
  path: '/admin/settings/',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminUsageIndexRoute = AdminUsageIndexRouteImport.update({
  id: '/admin/usage/',
  path: '/admin/usage/',
  getParentRoute: () => rootRouteImport,
} as any)
const COrgCodeTokenRoute = COrgCodeTokenRouteImport.update({
  id: '/c/$orgCode/$token',
  path: '/c/$orgCode/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const ROrgCodeAddressRoute = ROrgCodeAddressRouteImport.update({
  id: '/r/$orgCode/$address',
  path: '/r/$orgCode/$address',
  getParentRoute: () => rootRouteImport,
} as any)
const TestBareCrashRoute = TestBareCrashRouteImport.update({
  id: '/test/bare/crash',
  path: '/test/bare/crash',
  getParentRoute: () => rootRouteImport,
} as any)
const WoOrgCodeTokenRoute = WoOrgCodeTokenRouteImport.update({
  id: '/wo/$orgCode/$token',
  path: '/wo/$orgCode/$token',
  getParentRoute: () => rootRouteImport,
} as any)
const OrgAssembliesUidRoomRoute = OrgAssembliesUidRoomRouteImport.update({
  id: '/assemblies/$uid_/room',
  path: '/assemblies/$uid/room',
  getParentRoute: () => OrgRoute,
} as any)
const OrgAssetsAssetUidEditRoute = OrgAssetsAssetUidEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => OrgAssetsAssetUidRoute,
} as any)
const OrgAssetsAssetUidPlanEditorRoute =
  OrgAssetsAssetUidPlanEditorRouteImport.update({
    id: '/$assetUid_/plan-editor',
    path: '/$assetUid/plan-editor',
    getParentRoute: () => OrgAssetsRoute,
  } as any)
const OrgCampaignsCampaignUidIndexRoute =
  OrgCampaignsCampaignUidIndexRouteImport.update({
    id: '/campaigns/$campaignUid/',
    path: '/campaigns/$campaignUid/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgCampaignsCampaignUidEditRoute =
  OrgCampaignsCampaignUidEditRouteImport.update({
    id: '/campaigns/$campaignUid/edit',
    path: '/campaigns/$campaignUid/edit',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgExpensesExpenseUidEditRoute =
  OrgExpensesExpenseUidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => OrgExpensesExpenseUidRoute,
  } as any)
const OrgInterventionsInterventionUidEditRoute =
  OrgInterventionsInterventionUidEditRouteImport.update({
    id: '/edit',
    path: '/edit',
    getParentRoute: () => OrgInterventionsInterventionUidRoute,
  } as any)
const OrgIssuesUidEditRoute = OrgIssuesUidEditRouteImport.update({
  id: '/edit',
  path: '/edit',
  getParentRoute: () => OrgIssuesUidRoute,
} as any)
const OrgPropertiesPropertyUidIndexRoute =
  OrgPropertiesPropertyUidIndexRouteImport.update({
    id: '/properties/$propertyUid/',
    path: '/properties/$propertyUid/',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgPropertiesPropertyUidEditRoute =
  OrgPropertiesPropertyUidEditRouteImport.update({
    id: '/properties/$propertyUid/edit',
    path: '/properties/$propertyUid/edit',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgSettingsBillingIndexRoute = OrgSettingsBillingIndexRouteImport.update({
  id: '/billing/',
  path: '/billing/',
  getParentRoute: () => OrgSettingsRoute,
} as any)
const OrgSettingsFeatureFlagsIndexRoute =
  OrgSettingsFeatureFlagsIndexRouteImport.update({
    id: '/feature-flags/',
    path: '/feature-flags/',
    getParentRoute: () => OrgSettingsRoute,
  } as any)
const OrgSettingsMembersIndexRoute = OrgSettingsMembersIndexRouteImport.update({
  id: '/members/',
  path: '/members/',
  getParentRoute: () => OrgSettingsRoute,
} as any)
const OrgSettingsOrganizationIndexRoute =
  OrgSettingsOrganizationIndexRouteImport.update({
    id: '/organization/',
    path: '/organization/',
    getParentRoute: () => OrgSettingsRoute,
  } as any)
const OrgSettingsRolesIndexRoute = OrgSettingsRolesIndexRouteImport.update({
  id: '/roles/',
  path: '/roles/',
  getParentRoute: () => OrgSettingsRoute,
} as any)
const OrgSettingsSecurityIndexRoute =
  OrgSettingsSecurityIndexRouteImport.update({
    id: '/security/',
    path: '/security/',
    getParentRoute: () => OrgSettingsRoute,
  } as any)
const OrgSettingsTagsIndexRoute = OrgSettingsTagsIndexRouteImport.update({
  id: '/tags/',
  path: '/tags/',
  getParentRoute: () => OrgSettingsRoute,
} as any)
const OrgSettingsTagsTagIdRoute = OrgSettingsTagsTagIdRouteImport.update({
  id: '/tags/$tagId',
  path: '/tags/$tagId',
  getParentRoute: () => OrgSettingsRoute,
} as any)
const OrgSettingsWebhooksIndexRoute =
  OrgSettingsWebhooksIndexRouteImport.update({
    id: '/webhooks/',
    path: '/webhooks/',
    getParentRoute: () => OrgSettingsRoute,
  } as any)
const OrgSettingsWebhooksSubscriptionUidRoute =
  OrgSettingsWebhooksSubscriptionUidRouteImport.update({
    id: '/webhooks/$subscriptionUid',
    path: '/webhooks/$subscriptionUid',
    getParentRoute: () => OrgSettingsRoute,
  } as any)
const OrgTypesSyncIndexRoute = OrgTypesSyncIndexRouteImport.update({
  id: '/types/sync/',
  path: '/types/sync/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTypesThematicsIndexRoute = OrgTypesThematicsIndexRouteImport.update({
  id: '/types/thematics/',
  path: '/types/thematics/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTypesThematicsCodeRoute = OrgTypesThematicsCodeRouteImport.update({
  id: '/types/thematics/$code',
  path: '/types/thematics/$code',
  getParentRoute: () => OrgRoute,
} as any)
const OrgUserMeEmailIngestionRoute = OrgUserMeEmailIngestionRouteImport.update({
  id: '/email-ingestion',
  path: '/email-ingestion',
  getParentRoute: () => OrgUserMeRoute,
} as any)
const OrgUserMeNotificationsRoute = OrgUserMeNotificationsRouteImport.update({
  id: '/notifications',
  path: '/notifications',
  getParentRoute: () => OrgUserMeRoute,
} as any)
const OrgUserMePasskeysRoute = OrgUserMePasskeysRouteImport.update({
  id: '/passkeys',
  path: '/passkeys',
  getParentRoute: () => OrgUserMeRoute,
} as any)
const OrgUserMePatRoute = OrgUserMePatRouteImport.update({
  id: '/pat',
  path: '/pat',
  getParentRoute: () => OrgUserMeRoute,
} as any)
const OrgUserMeProfileRoute = OrgUserMeProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => OrgUserMeRoute,
} as any)
const OrgUserMeSecurityRoute = OrgUserMeSecurityRouteImport.update({
  id: '/security',
  path: '/security',
  getParentRoute: () => OrgUserMeRoute,
} as any)
const OrgUserMeSessionsRoute = OrgUserMeSessionsRouteImport.update({
  id: '/sessions',
  path: '/sessions',
  getParentRoute: () => OrgUserMeRoute,
} as any)
const OrgUsersUserUidIndexRoute = OrgUsersUserUidIndexRouteImport.update({
  id: '/users/$userUid/',
  path: '/users/$userUid/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgUsersUserUidSettingsRoute = OrgUsersUserUidSettingsRouteImport.update({
  id: '/users/$userUid/settings',
  path: '/users/$userUid/settings',
  getParentRoute: () => OrgRoute,
} as any)
const OrgUsersUserUidTokensRoute = OrgUsersUserUidTokensRouteImport.update({
  id: '/users/$userUid/tokens',
  path: '/users/$userUid/tokens',
  getParentRoute: () => OrgRoute,
} as any)
const OrgUsersMeSettingsRoute = OrgUsersMeSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => OrgUsersMeRoute,
} as any)
const AdminBillingInvoicesIndexRoute =
  AdminBillingInvoicesIndexRouteImport.update({
    id: '/admin/billing/invoices/',
    path: '/admin/billing/invoices/',
    getParentRoute: () => rootRouteImport,
  } as any)
const AdminBillingInvoicesUidRoute = AdminBillingInvoicesUidRouteImport.update({
  id: '/admin/billing/invoices/$uid',
  path: '/admin/billing/invoices/$uid',
  getParentRoute: () => rootRouteImport,
} as any)
const UOrgCodeTokenUnsubscribeRoute =
  UOrgCodeTokenUnsubscribeRouteImport.update({
    id: '/u/$orgCode/$token/unsubscribe',
    path: '/u/$orgCode/$token/unsubscribe',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrgCampaignsCampaignUidUnitsUnitUidRoute =
  OrgCampaignsCampaignUidUnitsUnitUidRouteImport.update({
    id: '/campaigns/$campaignUid/units/$unitUid',
    path: '/campaigns/$campaignUid/units/$unitUid',
    getParentRoute: () => OrgRoute,
  } as any)
const OrgSettingsMembersUserUidSessionsRoute =
  OrgSettingsMembersUserUidSessionsRouteImport.update({
    id: '/members/$userUid/sessions',
    path: '/members/$userUid/sessions',
    getParentRoute: () => OrgSettingsRoute,
  } as any)
const OrgTypesSyncRunsIndexRoute = OrgTypesSyncRunsIndexRouteImport.update({
  id: '/types/sync/runs/',
  path: '/types/sync/runs/',
  getParentRoute: () => OrgRoute,
} as any)
const OrgTypesSyncRunsRunUidRoute = OrgTypesSyncRunsRunUidRouteImport.update({
  id: '/types/sync/runs/$runUid',
  path: '/types/sync/runs/$runUid',
  getParentRoute: () => OrgRoute,
} as any)
const COrgCodeTokenViewingsViewingUidRoute =
  COrgCodeTokenViewingsViewingUidRouteImport.update({
    id: '/c/$orgCode/$token_/viewings/$viewingUid',
    path: '/c/$orgCode/$token/viewings/$viewingUid',
    getParentRoute: () => rootRouteImport,
  } as any)
const OrgJobsJobUidExecutionsExecutionUidIndexRoute =
  OrgJobsJobUidExecutionsExecutionUidIndexRouteImport.update({
    id: '/executions/$executionUid/',
    path: '/executions/$executionUid/',
    getParentRoute: () => OrgJobsJobUidRoute,
  } as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/$org': typeof OrgRouteWithChildren
  '/login': typeof LoginRoute
  '/mfa-setup': typeof MfaSetupRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/no-organization': typeof NoOrganizationRoute
  '/organizations': typeof OrganizationsRouteWithChildren
  '/$org/activity': typeof OrgActivityRoute
  '/$org/assets': typeof OrgAssetsRouteWithChildren
  '/$org/benchmark': typeof OrgBenchmarkRoute
  '/$org/business-rules': typeof OrgBusinessRulesRoute
  '/$org/conversations': typeof OrgConversationsRoute
  '/$org/createBuilding': typeof OrgCreateBuildingRoute
  '/$org/createBuildingGroup': typeof OrgCreateBuildingGroupRoute
  '/$org/data-protection': typeof OrgDataProtectionRoute
  '/$org/debug': typeof OrgDebugRoute
  '/$org/design-reference': typeof OrgDesignReferenceRoute
  '/$org/document-types': typeof OrgDocumentTypesRoute
  '/$org/documents': typeof OrgDocumentsRouteWithChildren
  '/$org/graph': typeof OrgGraphRoute
  '/$org/group': typeof OrgGroupRouteWithChildren
  '/$org/jobs': typeof OrgJobsRouteWithChildren
  '/$org/knowledge': typeof OrgKnowledgeRoute
  '/$org/login': typeof OrgLoginRoute
  '/$org/password-reset': typeof OrgPasswordResetRoute
  '/$org/patterns': typeof OrgPatternsRoute
  '/$org/plan-rendering': typeof OrgPlanRenderingRoute
  '/$org/reports': typeof OrgReportsRoute
  '/$org/search': typeof OrgSearchRoute
  '/$org/settings': typeof OrgSettingsRouteWithChildren
  '/$org/sign-in-link': typeof OrgSignInLinkRoute
  '/$org/steering': typeof OrgSteeringRoute
  '/$org/test-crash': typeof OrgTestCrashRoute
  '/$org/user': typeof OrgUserRouteWithChildren
  '/about/$slug': typeof AboutSlugRoute
  '/admin/proposed-rules': typeof AdminProposedRulesRoute
  '/admin/rent-indices': typeof AdminRentIndicesRoute
  '/impersonate/$token': typeof ImpersonateTokenRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/organizations/$orgCode': typeof OrganizationsOrgCodeRoute
  '/q/$code': typeof QCodeRoute
  '/s/$orgCode': typeof SOrgCodeRoute
  '/test/searcheable-select': typeof TestSearcheableSelectRoute
  '/v/$orgCode': typeof VOrgCodeRoute
  '/$org/': typeof OrgIndexRoute
  '/about/': typeof AboutIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/$org/agent-runs/$runUid': typeof OrgAgentRunsRunUidRoute
  '/$org/aggregations/$uid': typeof OrgAggregationsUidRoute
  '/$org/assemblies/$uid': typeof OrgAssembliesUidRoute
  '/$org/asset-types/$assetTypeUid': typeof OrgAssetTypesAssetTypeUidRoute
  '/$org/assets/$assetUid': typeof OrgAssetsAssetUidRouteWithChildren
  '/$org/assets/all': typeof OrgAssetsAllRoute
  '/$org/assets/createBasic': typeof OrgAssetsCreateBasicRoute
  '/$org/assets/old': typeof OrgAssetsOldRoute
  '/$org/campaigns/new': typeof OrgCampaignsNewRoute
  '/$org/capex-plans/$planUid': typeof OrgCapexPlansPlanUidRoute
  '/$org/compliance-controls/$controlUid': typeof OrgComplianceControlsControlUidRoute
  '/$org/compliance-controls/create': typeof OrgComplianceControlsCreateRoute
  '/$org/compliance-rules/$ruleUid': typeof OrgComplianceRulesRuleUidRoute
  '/$org/compliance-rules/create': typeof OrgComplianceRulesCreateRoute
  '/$org/contract-stakeholder-types/$contractStakeholderTypeUid': typeof OrgContractStakeholderTypesContractStakeholderTypeUidRoute
  '/$org/contract-stakeholder-types/create': typeof OrgContractStakeholderTypesCreateRoute
  '/$org/contract-types/$contractTypeUid': typeof OrgContractTypesContractTypeUidRoute
  '/$org/contract-types/create': typeof OrgContractTypesCreateRoute
  '/$org/contracts/$contractUid': typeof OrgContractsContractUidRoute
  '/$org/contracts/create': typeof OrgContractsCreateRoute
  '/$org/contracts/timeline': typeof OrgContractsTimelineRoute
  '/$org/conversations/intake-addresses': typeof OrgConversationsIntakeAddressesRoute
  '/$org/data/export': typeof OrgDataExportRoute
  '/$org/data/import': typeof OrgDataImportRoute
  '/$org/data/quality': typeof OrgDataQualityRoute
  '/$org/debug/annotations': typeof OrgDebugAnnotationsRoute
  '/$org/derivations/$uid': typeof OrgDerivationsUidRoute
  '/$org/documents/$docUid': typeof OrgDocumentsDocUidRoute
  '/$org/expenses/$expenseUid': typeof OrgExpensesExpenseUidRouteWithChildren
  '/$org/expenses/statement': typeof OrgExpensesStatementRoute
  '/$org/folder-layouts/$layoutUid': typeof OrgFolderLayoutsLayoutUidRoute
  '/$org/group/access': typeof OrgGroupAccessRoute
  '/$org/group/criteria': typeof OrgGroupCriteriaRoute
  '/$org/group/definitions': typeof OrgGroupDefinitionsRoute
  '/$org/group/governance': typeof OrgGroupGovernanceRoute
  '/$org/group/perimeters': typeof OrgGroupPerimetersRoute
  '/$org/group/sites': typeof OrgGroupSitesRoute
  '/$org/imports/$importUid': typeof OrgImportsImportUidRoute
  '/$org/interventions/$interventionUid': typeof OrgInterventionsInterventionUidRouteWithChildren
  '/$org/issues/$uid': typeof OrgIssuesUidRouteWithChildren
  '/$org/jobs/$jobUid': typeof OrgJobsJobUidRouteWithChildren
  '/$org/jobs/blockers': typeof OrgJobsBlockersRoute
  '/$org/labels/$code': typeof OrgLabelsCodeRoute
  '/$org/listings/$listingUid': typeof OrgListingsListingUidRoute
  '/$org/normalizations/$uid': typeof OrgNormalizationsUidRoute
  '/$org/properties/create': typeof OrgPropertiesCreateRoute
  '/$org/property-mapping-rules/$uid': typeof OrgPropertyMappingRulesUidRoute
  '/$org/relation-types/$relationTypeUid': typeof OrgRelationTypesRelationTypeUidRoute
  '/$org/relation-types/create': typeof OrgRelationTypesCreateRoute
  '/$org/remediation-scenarios/$code': typeof OrgRemediationScenariosCodeRoute
  '/$org/rental-applications/$applicationUid': typeof OrgRentalApplicationsApplicationUidRoute
  '/$org/rental-applications/viewings': typeof OrgRentalApplicationsViewingsRoute
  '/$org/settings/ai-models': typeof OrgSettingsAiModelsRoute
  '/$org/settings/archive': typeof OrgSettingsArchiveRoute
  '/$org/signatures/$uid': typeof OrgSignaturesUidRoute
  '/$org/tags/$tagCode': typeof OrgTagsTagCodeRoute
  '/$org/types/defaults': typeof OrgTypesDefaultsRoute
  '/$org/types/export': typeof OrgTypesExportRoute
  '/$org/types/import': typeof OrgTypesImportRoute
  '/$org/user/me': typeof OrgUserMeRouteWithChildren
  '/$org/users/create': typeof OrgUsersCreateRoute
  '/$org/users/me': typeof OrgUsersMeRouteWithChildren
  '/admin/billing/$orgUid': typeof AdminBillingOrgUidRoute
  '/admin/billing/prices': typeof AdminBillingPricesRoute
  '/admin/billing/simulator': typeof AdminBillingSimulatorRoute
  '/c/$orgCode/$token': typeof COrgCodeTokenRoute
  '/r/$orgCode/$address': typeof ROrgCodeAddressRoute
  '/test/bare/crash': typeof TestBareCrashRoute
  '/wo/$orgCode/$token': typeof WoOrgCodeTokenRoute
  '/$org/agent-runs/': typeof OrgAgentRunsIndexRoute
  '/$org/aggregations/': typeof OrgAggregationsIndexRoute
  '/$org/assemblies/': typeof OrgAssembliesIndexRoute
  '/$org/asset-types/': typeof OrgAssetTypesIndexRoute
  '/$org/assets/': typeof OrgAssetsIndexRoute
  '/$org/campaigns/': typeof OrgCampaignsIndexRoute
  '/$org/capex-plans/': typeof OrgCapexPlansIndexRoute
  '/$org/compliance-controls/': typeof OrgComplianceControlsIndexRoute
  '/$org/compliance-rules/': typeof OrgComplianceRulesIndexRoute
  '/$org/contract-stakeholder-types/': typeof OrgContractStakeholderTypesIndexRoute
  '/$org/contract-types/': typeof OrgContractTypesIndexRoute
  '/$org/contracts/': typeof OrgContractsIndexRoute
  '/$org/data/': typeof OrgDataIndexRoute
  '/$org/derivations/': typeof OrgDerivationsIndexRoute
  '/$org/documents/': typeof OrgDocumentsIndexRoute
  '/$org/expenses/': typeof OrgExpensesIndexRoute
  '/$org/folder-layouts/': typeof OrgFolderLayoutsIndexRoute
  '/$org/group/': typeof OrgGroupIndexRoute
  '/$org/imports/': typeof OrgImportsIndexRoute
  '/$org/interventions/': typeof OrgInterventionsIndexRoute
  '/$org/issues/': typeof OrgIssuesIndexRoute
  '/$org/jobs/': typeof OrgJobsIndexRoute
  '/$org/leases/': typeof OrgLeasesIndexRoute
  '/$org/listings/': typeof OrgListingsIndexRoute
  '/$org/normalizations/': typeof OrgNormalizationsIndexRoute
  '/$org/properties/': typeof OrgPropertiesIndexRoute
  '/$org/property-mapping-rules/': typeof OrgPropertyMappingRulesIndexRoute
  '/$org/relation-types/': typeof OrgRelationTypesIndexRoute
  '/$org/remediation-scenarios/': typeof OrgRemediationScenariosIndexRoute
  '/$org/rental-applications/': typeof OrgRentalApplicationsIndexRoute
  '/$org/signatures/': typeof OrgSignaturesIndexRoute
  '/$org/tags/': typeof OrgTagsIndexRoute
  '/$org/types/': typeof OrgTypesIndexRoute
  '/$org/users/': typeof OrgUsersIndexRoute
  '/admin/agent-pool/': typeof AdminAgentPoolIndexRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/usage/': typeof AdminUsageIndexRoute
  '/$org/assemblies/$uid/room': typeof OrgAssembliesUidRoomRoute
  '/$org/assets/$assetUid/edit': typeof OrgAssetsAssetUidEditRoute
  '/$org/assets/$assetUid/plan-editor': typeof OrgAssetsAssetUidPlanEditorRoute
  '/$org/campaigns/$campaignUid/edit': typeof OrgCampaignsCampaignUidEditRoute
  '/$org/expenses/$expenseUid/edit': typeof OrgExpensesExpenseUidEditRoute
  '/$org/interventions/$interventionUid/edit': typeof OrgInterventionsInterventionUidEditRoute
  '/$org/issues/$uid/edit': typeof OrgIssuesUidEditRoute
  '/$org/properties/$propertyUid/edit': typeof OrgPropertiesPropertyUidEditRoute
  '/$org/settings/tags/$tagId': typeof OrgSettingsTagsTagIdRoute
  '/$org/settings/webhooks/$subscriptionUid': typeof OrgSettingsWebhooksSubscriptionUidRoute
  '/$org/types/thematics/$code': typeof OrgTypesThematicsCodeRoute
  '/$org/user/me/email-ingestion': typeof OrgUserMeEmailIngestionRoute
  '/$org/user/me/notifications': typeof OrgUserMeNotificationsRoute
  '/$org/user/me/passkeys': typeof OrgUserMePasskeysRoute
  '/$org/user/me/pat': typeof OrgUserMePatRoute
  '/$org/user/me/profile': typeof OrgUserMeProfileRoute
  '/$org/user/me/security': typeof OrgUserMeSecurityRoute
  '/$org/user/me/sessions': typeof OrgUserMeSessionsRoute
  '/$org/users/$userUid/settings': typeof OrgUsersUserUidSettingsRoute
  '/$org/users/$userUid/tokens': typeof OrgUsersUserUidTokensRoute
  '/$org/users/me/settings': typeof OrgUsersMeSettingsRoute
  '/admin/billing/invoices/$uid': typeof AdminBillingInvoicesUidRoute
  '/u/$orgCode/$token/unsubscribe': typeof UOrgCodeTokenUnsubscribeRoute
  '/$org/campaigns/$campaignUid/': typeof OrgCampaignsCampaignUidIndexRoute
  '/$org/properties/$propertyUid/': typeof OrgPropertiesPropertyUidIndexRoute
  '/$org/settings/billing/': typeof OrgSettingsBillingIndexRoute
  '/$org/settings/feature-flags/': typeof OrgSettingsFeatureFlagsIndexRoute
  '/$org/settings/members/': typeof OrgSettingsMembersIndexRoute
  '/$org/settings/organization/': typeof OrgSettingsOrganizationIndexRoute
  '/$org/settings/roles/': typeof OrgSettingsRolesIndexRoute
  '/$org/settings/security/': typeof OrgSettingsSecurityIndexRoute
  '/$org/settings/tags/': typeof OrgSettingsTagsIndexRoute
  '/$org/settings/webhooks/': typeof OrgSettingsWebhooksIndexRoute
  '/$org/types/sync/': typeof OrgTypesSyncIndexRoute
  '/$org/types/thematics/': typeof OrgTypesThematicsIndexRoute
  '/$org/users/$userUid/': typeof OrgUsersUserUidIndexRoute
  '/admin/billing/invoices/': typeof AdminBillingInvoicesIndexRoute
  '/$org/campaigns/$campaignUid/units/$unitUid': typeof OrgCampaignsCampaignUidUnitsUnitUidRoute
  '/$org/settings/members/$userUid/sessions': typeof OrgSettingsMembersUserUidSessionsRoute
  '/$org/types/sync/runs/$runUid': typeof OrgTypesSyncRunsRunUidRoute
  '/c/$orgCode/$token/viewings/$viewingUid': typeof COrgCodeTokenViewingsViewingUidRoute
  '/$org/types/sync/runs/': typeof OrgTypesSyncRunsIndexRoute
  '/$org/jobs/$jobUid/executions/$executionUid/': typeof OrgJobsJobUidExecutionsExecutionUidIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/login': typeof LoginRoute
  '/mfa-setup': typeof MfaSetupRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/no-organization': typeof NoOrganizationRoute
  '/$org/activity': typeof OrgActivityRoute
  '/$org/benchmark': typeof OrgBenchmarkRoute
  '/$org/business-rules': typeof OrgBusinessRulesRoute
  '/$org/conversations': typeof OrgConversationsRoute
  '/$org/createBuilding': typeof OrgCreateBuildingRoute
  '/$org/createBuildingGroup': typeof OrgCreateBuildingGroupRoute
  '/$org/data-protection': typeof OrgDataProtectionRoute
  '/$org/debug': typeof OrgDebugRoute
  '/$org/design-reference': typeof OrgDesignReferenceRoute
  '/$org/document-types': typeof OrgDocumentTypesRoute
  '/$org/graph': typeof OrgGraphRoute
  '/$org/knowledge': typeof OrgKnowledgeRoute
  '/$org/login': typeof OrgLoginRoute
  '/$org/password-reset': typeof OrgPasswordResetRoute
  '/$org/patterns': typeof OrgPatternsRoute
  '/$org/plan-rendering': typeof OrgPlanRenderingRoute
  '/$org/reports': typeof OrgReportsRoute
  '/$org/search': typeof OrgSearchRoute
  '/$org/settings': typeof OrgSettingsRouteWithChildren
  '/$org/sign-in-link': typeof OrgSignInLinkRoute
  '/$org/steering': typeof OrgSteeringRoute
  '/$org/test-crash': typeof OrgTestCrashRoute
  '/$org/user': typeof OrgUserRouteWithChildren
  '/about/$slug': typeof AboutSlugRoute
  '/admin/proposed-rules': typeof AdminProposedRulesRoute
  '/admin/rent-indices': typeof AdminRentIndicesRoute
  '/impersonate/$token': typeof ImpersonateTokenRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/organizations/$orgCode': typeof OrganizationsOrgCodeRoute
  '/q/$code': typeof QCodeRoute
  '/s/$orgCode': typeof SOrgCodeRoute
  '/test/searcheable-select': typeof TestSearcheableSelectRoute
  '/v/$orgCode': typeof VOrgCodeRoute
  '/$org': typeof OrgIndexRoute
  '/about': typeof AboutIndexRoute
  '/organizations': typeof OrganizationsIndexRoute
  '/$org/agent-runs/$runUid': typeof OrgAgentRunsRunUidRoute
  '/$org/aggregations/$uid': typeof OrgAggregationsUidRoute
  '/$org/assemblies/$uid': typeof OrgAssembliesUidRoute
  '/$org/asset-types/$assetTypeUid': typeof OrgAssetTypesAssetTypeUidRoute
  '/$org/assets/$assetUid': typeof OrgAssetsAssetUidRouteWithChildren
  '/$org/assets/all': typeof OrgAssetsAllRoute
  '/$org/assets/createBasic': typeof OrgAssetsCreateBasicRoute
  '/$org/assets/old': typeof OrgAssetsOldRoute
  '/$org/campaigns/new': typeof OrgCampaignsNewRoute
  '/$org/capex-plans/$planUid': typeof OrgCapexPlansPlanUidRoute
  '/$org/compliance-controls/$controlUid': typeof OrgComplianceControlsControlUidRoute
  '/$org/compliance-controls/create': typeof OrgComplianceControlsCreateRoute
  '/$org/compliance-rules/$ruleUid': typeof OrgComplianceRulesRuleUidRoute
  '/$org/compliance-rules/create': typeof OrgComplianceRulesCreateRoute
  '/$org/contract-stakeholder-types/$contractStakeholderTypeUid': typeof OrgContractStakeholderTypesContractStakeholderTypeUidRoute
  '/$org/contract-stakeholder-types/create': typeof OrgContractStakeholderTypesCreateRoute
  '/$org/contract-types/$contractTypeUid': typeof OrgContractTypesContractTypeUidRoute
  '/$org/contract-types/create': typeof OrgContractTypesCreateRoute
  '/$org/contracts/$contractUid': typeof OrgContractsContractUidRoute
  '/$org/contracts/create': typeof OrgContractsCreateRoute
  '/$org/contracts/timeline': typeof OrgContractsTimelineRoute
  '/$org/conversations/intake-addresses': typeof OrgConversationsIntakeAddressesRoute
  '/$org/data/export': typeof OrgDataExportRoute
  '/$org/data/import': typeof OrgDataImportRoute
  '/$org/data/quality': typeof OrgDataQualityRoute
  '/$org/debug/annotations': typeof OrgDebugAnnotationsRoute
  '/$org/derivations/$uid': typeof OrgDerivationsUidRoute
  '/$org/documents/$docUid': typeof OrgDocumentsDocUidRoute
  '/$org/expenses/$expenseUid': typeof OrgExpensesExpenseUidRouteWithChildren
  '/$org/expenses/statement': typeof OrgExpensesStatementRoute
  '/$org/folder-layouts/$layoutUid': typeof OrgFolderLayoutsLayoutUidRoute
  '/$org/group/access': typeof OrgGroupAccessRoute
  '/$org/group/criteria': typeof OrgGroupCriteriaRoute
  '/$org/group/definitions': typeof OrgGroupDefinitionsRoute
  '/$org/group/governance': typeof OrgGroupGovernanceRoute
  '/$org/group/perimeters': typeof OrgGroupPerimetersRoute
  '/$org/group/sites': typeof OrgGroupSitesRoute
  '/$org/imports/$importUid': typeof OrgImportsImportUidRoute
  '/$org/interventions/$interventionUid': typeof OrgInterventionsInterventionUidRouteWithChildren
  '/$org/issues/$uid': typeof OrgIssuesUidRouteWithChildren
  '/$org/jobs/$jobUid': typeof OrgJobsJobUidRouteWithChildren
  '/$org/jobs/blockers': typeof OrgJobsBlockersRoute
  '/$org/labels/$code': typeof OrgLabelsCodeRoute
  '/$org/listings/$listingUid': typeof OrgListingsListingUidRoute
  '/$org/normalizations/$uid': typeof OrgNormalizationsUidRoute
  '/$org/properties/create': typeof OrgPropertiesCreateRoute
  '/$org/property-mapping-rules/$uid': typeof OrgPropertyMappingRulesUidRoute
  '/$org/relation-types/$relationTypeUid': typeof OrgRelationTypesRelationTypeUidRoute
  '/$org/relation-types/create': typeof OrgRelationTypesCreateRoute
  '/$org/remediation-scenarios/$code': typeof OrgRemediationScenariosCodeRoute
  '/$org/rental-applications/$applicationUid': typeof OrgRentalApplicationsApplicationUidRoute
  '/$org/rental-applications/viewings': typeof OrgRentalApplicationsViewingsRoute
  '/$org/settings/ai-models': typeof OrgSettingsAiModelsRoute
  '/$org/settings/archive': typeof OrgSettingsArchiveRoute
  '/$org/signatures/$uid': typeof OrgSignaturesUidRoute
  '/$org/tags/$tagCode': typeof OrgTagsTagCodeRoute
  '/$org/types/defaults': typeof OrgTypesDefaultsRoute
  '/$org/types/export': typeof OrgTypesExportRoute
  '/$org/types/import': typeof OrgTypesImportRoute
  '/$org/user/me': typeof OrgUserMeRouteWithChildren
  '/$org/users/create': typeof OrgUsersCreateRoute
  '/$org/users/me': typeof OrgUsersMeRouteWithChildren
  '/admin/billing/$orgUid': typeof AdminBillingOrgUidRoute
  '/admin/billing/prices': typeof AdminBillingPricesRoute
  '/admin/billing/simulator': typeof AdminBillingSimulatorRoute
  '/c/$orgCode/$token': typeof COrgCodeTokenRoute
  '/r/$orgCode/$address': typeof ROrgCodeAddressRoute
  '/test/bare/crash': typeof TestBareCrashRoute
  '/wo/$orgCode/$token': typeof WoOrgCodeTokenRoute
  '/$org/agent-runs': typeof OrgAgentRunsIndexRoute
  '/$org/aggregations': typeof OrgAggregationsIndexRoute
  '/$org/assemblies': typeof OrgAssembliesIndexRoute
  '/$org/asset-types': typeof OrgAssetTypesIndexRoute
  '/$org/assets': typeof OrgAssetsIndexRoute
  '/$org/campaigns': typeof OrgCampaignsIndexRoute
  '/$org/capex-plans': typeof OrgCapexPlansIndexRoute
  '/$org/compliance-controls': typeof OrgComplianceControlsIndexRoute
  '/$org/compliance-rules': typeof OrgComplianceRulesIndexRoute
  '/$org/contract-stakeholder-types': typeof OrgContractStakeholderTypesIndexRoute
  '/$org/contract-types': typeof OrgContractTypesIndexRoute
  '/$org/contracts': typeof OrgContractsIndexRoute
  '/$org/data': typeof OrgDataIndexRoute
  '/$org/derivations': typeof OrgDerivationsIndexRoute
  '/$org/documents': typeof OrgDocumentsIndexRoute
  '/$org/expenses': typeof OrgExpensesIndexRoute
  '/$org/folder-layouts': typeof OrgFolderLayoutsIndexRoute
  '/$org/group': typeof OrgGroupIndexRoute
  '/$org/imports': typeof OrgImportsIndexRoute
  '/$org/interventions': typeof OrgInterventionsIndexRoute
  '/$org/issues': typeof OrgIssuesIndexRoute
  '/$org/jobs': typeof OrgJobsIndexRoute
  '/$org/leases': typeof OrgLeasesIndexRoute
  '/$org/listings': typeof OrgListingsIndexRoute
  '/$org/normalizations': typeof OrgNormalizationsIndexRoute
  '/$org/properties': typeof OrgPropertiesIndexRoute
  '/$org/property-mapping-rules': typeof OrgPropertyMappingRulesIndexRoute
  '/$org/relation-types': typeof OrgRelationTypesIndexRoute
  '/$org/remediation-scenarios': typeof OrgRemediationScenariosIndexRoute
  '/$org/rental-applications': typeof OrgRentalApplicationsIndexRoute
  '/$org/signatures': typeof OrgSignaturesIndexRoute
  '/$org/tags': typeof OrgTagsIndexRoute
  '/$org/types': typeof OrgTypesIndexRoute
  '/$org/users': typeof OrgUsersIndexRoute
  '/admin/agent-pool': typeof AdminAgentPoolIndexRoute
  '/admin/billing': typeof AdminBillingIndexRoute
  '/admin/organizations': typeof AdminOrganizationsIndexRoute
  '/admin/settings': typeof AdminSettingsIndexRoute
  '/admin/usage': typeof AdminUsageIndexRoute
  '/$org/assemblies/$uid/room': typeof OrgAssembliesUidRoomRoute
  '/$org/assets/$assetUid/edit': typeof OrgAssetsAssetUidEditRoute
  '/$org/assets/$assetUid/plan-editor': typeof OrgAssetsAssetUidPlanEditorRoute
  '/$org/campaigns/$campaignUid/edit': typeof OrgCampaignsCampaignUidEditRoute
  '/$org/expenses/$expenseUid/edit': typeof OrgExpensesExpenseUidEditRoute
  '/$org/interventions/$interventionUid/edit': typeof OrgInterventionsInterventionUidEditRoute
  '/$org/issues/$uid/edit': typeof OrgIssuesUidEditRoute
  '/$org/properties/$propertyUid/edit': typeof OrgPropertiesPropertyUidEditRoute
  '/$org/settings/tags/$tagId': typeof OrgSettingsTagsTagIdRoute
  '/$org/settings/webhooks/$subscriptionUid': typeof OrgSettingsWebhooksSubscriptionUidRoute
  '/$org/types/thematics/$code': typeof OrgTypesThematicsCodeRoute
  '/$org/user/me/email-ingestion': typeof OrgUserMeEmailIngestionRoute
  '/$org/user/me/notifications': typeof OrgUserMeNotificationsRoute
  '/$org/user/me/passkeys': typeof OrgUserMePasskeysRoute
  '/$org/user/me/pat': typeof OrgUserMePatRoute
  '/$org/user/me/profile': typeof OrgUserMeProfileRoute
  '/$org/user/me/security': typeof OrgUserMeSecurityRoute
  '/$org/user/me/sessions': typeof OrgUserMeSessionsRoute
  '/$org/users/$userUid/settings': typeof OrgUsersUserUidSettingsRoute
  '/$org/users/$userUid/tokens': typeof OrgUsersUserUidTokensRoute
  '/$org/users/me/settings': typeof OrgUsersMeSettingsRoute
  '/admin/billing/invoices/$uid': typeof AdminBillingInvoicesUidRoute
  '/u/$orgCode/$token/unsubscribe': typeof UOrgCodeTokenUnsubscribeRoute
  '/$org/campaigns/$campaignUid': typeof OrgCampaignsCampaignUidIndexRoute
  '/$org/properties/$propertyUid': typeof OrgPropertiesPropertyUidIndexRoute
  '/$org/settings/billing': typeof OrgSettingsBillingIndexRoute
  '/$org/settings/feature-flags': typeof OrgSettingsFeatureFlagsIndexRoute
  '/$org/settings/members': typeof OrgSettingsMembersIndexRoute
  '/$org/settings/organization': typeof OrgSettingsOrganizationIndexRoute
  '/$org/settings/roles': typeof OrgSettingsRolesIndexRoute
  '/$org/settings/security': typeof OrgSettingsSecurityIndexRoute
  '/$org/settings/tags': typeof OrgSettingsTagsIndexRoute
  '/$org/settings/webhooks': typeof OrgSettingsWebhooksIndexRoute
  '/$org/types/sync': typeof OrgTypesSyncIndexRoute
  '/$org/types/thematics': typeof OrgTypesThematicsIndexRoute
  '/$org/users/$userUid': typeof OrgUsersUserUidIndexRoute
  '/admin/billing/invoices': typeof AdminBillingInvoicesIndexRoute
  '/$org/campaigns/$campaignUid/units/$unitUid': typeof OrgCampaignsCampaignUidUnitsUnitUidRoute
  '/$org/settings/members/$userUid/sessions': typeof OrgSettingsMembersUserUidSessionsRoute
  '/$org/types/sync/runs/$runUid': typeof OrgTypesSyncRunsRunUidRoute
  '/c/$orgCode/$token/viewings/$viewingUid': typeof COrgCodeTokenViewingsViewingUidRoute
  '/$org/types/sync/runs': typeof OrgTypesSyncRunsIndexRoute
  '/$org/jobs/$jobUid/executions/$executionUid': typeof OrgJobsJobUidExecutionsExecutionUidIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/$org': typeof OrgRouteWithChildren
  '/login': typeof LoginRoute
  '/mfa-setup': typeof MfaSetupRoute
  '/mfa-verify': typeof MfaVerifyRoute
  '/no-organization': typeof NoOrganizationRoute
  '/organizations': typeof OrganizationsRouteWithChildren
  '/$org/activity': typeof OrgActivityRoute
  '/$org/assets': typeof OrgAssetsRouteWithChildren
  '/$org/benchmark': typeof OrgBenchmarkRoute
  '/$org/business-rules': typeof OrgBusinessRulesRoute
  '/$org/conversations': typeof OrgConversationsRoute
  '/$org/createBuilding': typeof OrgCreateBuildingRoute
  '/$org/createBuildingGroup': typeof OrgCreateBuildingGroupRoute
  '/$org/data-protection': typeof OrgDataProtectionRoute
  '/$org/debug': typeof OrgDebugRoute
  '/$org/design-reference': typeof OrgDesignReferenceRoute
  '/$org/document-types': typeof OrgDocumentTypesRoute
  '/$org/documents': typeof OrgDocumentsRouteWithChildren
  '/$org/graph': typeof OrgGraphRoute
  '/$org/group': typeof OrgGroupRouteWithChildren
  '/$org/jobs': typeof OrgJobsRouteWithChildren
  '/$org/knowledge': typeof OrgKnowledgeRoute
  '/$org/login': typeof OrgLoginRoute
  '/$org/password-reset': typeof OrgPasswordResetRoute
  '/$org/patterns': typeof OrgPatternsRoute
  '/$org/plan-rendering': typeof OrgPlanRenderingRoute
  '/$org/reports': typeof OrgReportsRoute
  '/$org/search': typeof OrgSearchRoute
  '/$org/settings': typeof OrgSettingsRouteWithChildren
  '/$org/sign-in-link': typeof OrgSignInLinkRoute
  '/$org/steering': typeof OrgSteeringRoute
  '/$org/test-crash': typeof OrgTestCrashRoute
  '/$org/user': typeof OrgUserRouteWithChildren
  '/about/$slug': typeof AboutSlugRoute
  '/admin/proposed-rules': typeof AdminProposedRulesRoute
  '/admin/rent-indices': typeof AdminRentIndicesRoute
  '/impersonate/$token': typeof ImpersonateTokenRoute
  '/invitations/$token': typeof InvitationsTokenRoute
  '/organizations/$orgCode': typeof OrganizationsOrgCodeRoute
  '/q/$code': typeof QCodeRoute
  '/s/$orgCode': typeof SOrgCodeRoute
  '/test/searcheable-select': typeof TestSearcheableSelectRoute
  '/v/$orgCode': typeof VOrgCodeRoute
  '/$org/': typeof OrgIndexRoute
  '/about/': typeof AboutIndexRoute
  '/organizations/': typeof OrganizationsIndexRoute
  '/$org/agent-runs/$runUid': typeof OrgAgentRunsRunUidRoute
  '/$org/aggregations/$uid': typeof OrgAggregationsUidRoute
  '/$org/assemblies/$uid': typeof OrgAssembliesUidRoute
  '/$org/asset-types/$assetTypeUid': typeof OrgAssetTypesAssetTypeUidRoute
  '/$org/assets/$assetUid': typeof OrgAssetsAssetUidRouteWithChildren
  '/$org/assets/all': typeof OrgAssetsAllRoute
  '/$org/assets/createBasic': typeof OrgAssetsCreateBasicRoute
  '/$org/assets/old': typeof OrgAssetsOldRoute
  '/$org/campaigns/new': typeof OrgCampaignsNewRoute
  '/$org/capex-plans/$planUid': typeof OrgCapexPlansPlanUidRoute
  '/$org/compliance-controls/$controlUid': typeof OrgComplianceControlsControlUidRoute
  '/$org/compliance-controls/create': typeof OrgComplianceControlsCreateRoute
  '/$org/compliance-rules/$ruleUid': typeof OrgComplianceRulesRuleUidRoute
  '/$org/compliance-rules/create': typeof OrgComplianceRulesCreateRoute
  '/$org/contract-stakeholder-types/$contractStakeholderTypeUid': typeof OrgContractStakeholderTypesContractStakeholderTypeUidRoute
  '/$org/contract-stakeholder-types/create': typeof OrgContractStakeholderTypesCreateRoute
  '/$org/contract-types/$contractTypeUid': typeof OrgContractTypesContractTypeUidRoute
  '/$org/contract-types/create': typeof OrgContractTypesCreateRoute
  '/$org/contracts/$contractUid': typeof OrgContractsContractUidRoute
  '/$org/contracts/create': typeof OrgContractsCreateRoute
  '/$org/contracts/timeline': typeof OrgContractsTimelineRoute
  '/$org/conversations_/intake-addresses': typeof OrgConversationsIntakeAddressesRoute
  '/$org/data/export': typeof OrgDataExportRoute
  '/$org/data/import': typeof OrgDataImportRoute
  '/$org/data/quality': typeof OrgDataQualityRoute
  '/$org/debug_/annotations': typeof OrgDebugAnnotationsRoute
  '/$org/derivations/$uid': typeof OrgDerivationsUidRoute
  '/$org/documents/$docUid': typeof OrgDocumentsDocUidRoute
  '/$org/expenses/$expenseUid': typeof OrgExpensesExpenseUidRouteWithChildren
  '/$org/expenses/statement': typeof OrgExpensesStatementRoute
  '/$org/folder-layouts/$layoutUid': typeof OrgFolderLayoutsLayoutUidRoute
  '/$org/group/access': typeof OrgGroupAccessRoute
  '/$org/group/criteria': typeof OrgGroupCriteriaRoute
  '/$org/group/definitions': typeof OrgGroupDefinitionsRoute
  '/$org/group/governance': typeof OrgGroupGovernanceRoute
  '/$org/group/perimeters': typeof OrgGroupPerimetersRoute
  '/$org/group/sites': typeof OrgGroupSitesRoute
  '/$org/imports/$importUid': typeof OrgImportsImportUidRoute
  '/$org/interventions/$interventionUid': typeof OrgInterventionsInterventionUidRouteWithChildren
  '/$org/issues/$uid': typeof OrgIssuesUidRouteWithChildren
  '/$org/jobs/$jobUid': typeof OrgJobsJobUidRouteWithChildren
  '/$org/jobs/blockers': typeof OrgJobsBlockersRoute
  '/$org/labels/$code': typeof OrgLabelsCodeRoute
  '/$org/listings/$listingUid': typeof OrgListingsListingUidRoute
  '/$org/normalizations/$uid': typeof OrgNormalizationsUidRoute
  '/$org/properties/create': typeof OrgPropertiesCreateRoute
  '/$org/property-mapping-rules/$uid': typeof OrgPropertyMappingRulesUidRoute
  '/$org/relation-types/$relationTypeUid': typeof OrgRelationTypesRelationTypeUidRoute
  '/$org/relation-types/create': typeof OrgRelationTypesCreateRoute
  '/$org/remediation-scenarios/$code': typeof OrgRemediationScenariosCodeRoute
  '/$org/rental-applications/$applicationUid': typeof OrgRentalApplicationsApplicationUidRoute
  '/$org/rental-applications/viewings': typeof OrgRentalApplicationsViewingsRoute
  '/$org/settings/ai-models': typeof OrgSettingsAiModelsRoute
  '/$org/settings/archive': typeof OrgSettingsArchiveRoute
  '/$org/signatures/$uid': typeof OrgSignaturesUidRoute
  '/$org/tags/$tagCode': typeof OrgTagsTagCodeRoute
  '/$org/types/defaults': typeof OrgTypesDefaultsRoute
  '/$org/types/export': typeof OrgTypesExportRoute
  '/$org/types/import': typeof OrgTypesImportRoute
  '/$org/user/me': typeof OrgUserMeRouteWithChildren
  '/$org/users/create': typeof OrgUsersCreateRoute
  '/$org/users/me': typeof OrgUsersMeRouteWithChildren
  '/admin/billing/$orgUid': typeof AdminBillingOrgUidRoute
  '/admin/billing/prices': typeof AdminBillingPricesRoute
  '/admin/billing/simulator': typeof AdminBillingSimulatorRoute
  '/c/$orgCode/$token': typeof COrgCodeTokenRoute
  '/r/$orgCode/$address': typeof ROrgCodeAddressRoute
  '/test/bare/crash': typeof TestBareCrashRoute
  '/wo/$orgCode/$token': typeof WoOrgCodeTokenRoute
  '/$org/agent-runs/': typeof OrgAgentRunsIndexRoute
  '/$org/aggregations/': typeof OrgAggregationsIndexRoute
  '/$org/assemblies/': typeof OrgAssembliesIndexRoute
  '/$org/asset-types/': typeof OrgAssetTypesIndexRoute
  '/$org/assets/': typeof OrgAssetsIndexRoute
  '/$org/campaigns/': typeof OrgCampaignsIndexRoute
  '/$org/capex-plans/': typeof OrgCapexPlansIndexRoute
  '/$org/compliance-controls/': typeof OrgComplianceControlsIndexRoute
  '/$org/compliance-rules/': typeof OrgComplianceRulesIndexRoute
  '/$org/contract-stakeholder-types/': typeof OrgContractStakeholderTypesIndexRoute
  '/$org/contract-types/': typeof OrgContractTypesIndexRoute
  '/$org/contracts/': typeof OrgContractsIndexRoute
  '/$org/data/': typeof OrgDataIndexRoute
  '/$org/derivations/': typeof OrgDerivationsIndexRoute
  '/$org/documents/': typeof OrgDocumentsIndexRoute
  '/$org/expenses/': typeof OrgExpensesIndexRoute
  '/$org/folder-layouts/': typeof OrgFolderLayoutsIndexRoute
  '/$org/group/': typeof OrgGroupIndexRoute
  '/$org/imports/': typeof OrgImportsIndexRoute
  '/$org/interventions/': typeof OrgInterventionsIndexRoute
  '/$org/issues/': typeof OrgIssuesIndexRoute
  '/$org/jobs/': typeof OrgJobsIndexRoute
  '/$org/leases/': typeof OrgLeasesIndexRoute
  '/$org/listings/': typeof OrgListingsIndexRoute
  '/$org/normalizations/': typeof OrgNormalizationsIndexRoute
  '/$org/properties/': typeof OrgPropertiesIndexRoute
  '/$org/property-mapping-rules/': typeof OrgPropertyMappingRulesIndexRoute
  '/$org/relation-types/': typeof OrgRelationTypesIndexRoute
  '/$org/remediation-scenarios/': typeof OrgRemediationScenariosIndexRoute
  '/$org/rental-applications/': typeof OrgRentalApplicationsIndexRoute
  '/$org/signatures/': typeof OrgSignaturesIndexRoute
  '/$org/tags/': typeof OrgTagsIndexRoute
  '/$org/types/': typeof OrgTypesIndexRoute
  '/$org/users/': typeof OrgUsersIndexRoute
  '/admin/agent-pool/': typeof AdminAgentPoolIndexRoute
  '/admin/billing/': typeof AdminBillingIndexRoute
  '/admin/organizations/': typeof AdminOrganizationsIndexRoute
  '/admin/settings/': typeof AdminSettingsIndexRoute
  '/admin/usage/': typeof AdminUsageIndexRoute
  '/$org/assemblies/$uid_/room': typeof OrgAssembliesUidRoomRoute
  '/$org/assets/$assetUid/edit': typeof OrgAssetsAssetUidEditRoute
  '/$org/assets/$assetUid_/plan-editor': typeof OrgAssetsAssetUidPlanEditorRoute
  '/$org/campaigns/$campaignUid/edit': typeof OrgCampaignsCampaignUidEditRoute
  '/$org/expenses/$expenseUid/edit': typeof OrgExpensesExpenseUidEditRoute
  '/$org/interventions/$interventionUid/edit': typeof OrgInterventionsInterventionUidEditRoute
  '/$org/issues/$uid/edit': typeof OrgIssuesUidEditRoute
  '/$org/properties/$propertyUid/edit': typeof OrgPropertiesPropertyUidEditRoute
  '/$org/settings/tags/$tagId': typeof OrgSettingsTagsTagIdRoute
  '/$org/settings/webhooks/$subscriptionUid': typeof OrgSettingsWebhooksSubscriptionUidRoute
  '/$org/types/thematics/$code': typeof OrgTypesThematicsCodeRoute
  '/$org/user/me/email-ingestion': typeof OrgUserMeEmailIngestionRoute
  '/$org/user/me/notifications': typeof OrgUserMeNotificationsRoute
  '/$org/user/me/passkeys': typeof OrgUserMePasskeysRoute
  '/$org/user/me/pat': typeof OrgUserMePatRoute
  '/$org/user/me/profile': typeof OrgUserMeProfileRoute
  '/$org/user/me/security': typeof OrgUserMeSecurityRoute
  '/$org/user/me/sessions': typeof OrgUserMeSessionsRoute
  '/$org/users/$userUid/settings': typeof OrgUsersUserUidSettingsRoute
  '/$org/users/$userUid/tokens': typeof OrgUsersUserUidTokensRoute
  '/$org/users/me/settings': typeof OrgUsersMeSettingsRoute
  '/admin/billing/invoices/$uid': typeof AdminBillingInvoicesUidRoute
  '/u/$orgCode/$token/unsubscribe': typeof UOrgCodeTokenUnsubscribeRoute
  '/$org/campaigns/$campaignUid/': typeof OrgCampaignsCampaignUidIndexRoute
  '/$org/properties/$propertyUid/': typeof OrgPropertiesPropertyUidIndexRoute
  '/$org/settings/billing/': typeof OrgSettingsBillingIndexRoute
  '/$org/settings/feature-flags/': typeof OrgSettingsFeatureFlagsIndexRoute
  '/$org/settings/members/': typeof OrgSettingsMembersIndexRoute
  '/$org/settings/organization/': typeof OrgSettingsOrganizationIndexRoute
  '/$org/settings/roles/': typeof OrgSettingsRolesIndexRoute
  '/$org/settings/security/': typeof OrgSettingsSecurityIndexRoute
  '/$org/settings/tags/': typeof OrgSettingsTagsIndexRoute
  '/$org/settings/webhooks/': typeof OrgSettingsWebhooksIndexRoute
  '/$org/types/sync/': typeof OrgTypesSyncIndexRoute
  '/$org/types/thematics/': typeof OrgTypesThematicsIndexRoute
  '/$org/users/$userUid/': typeof OrgUsersUserUidIndexRoute
  '/admin/billing/invoices/': typeof AdminBillingInvoicesIndexRoute
  '/$org/campaigns/$campaignUid/units/$unitUid': typeof OrgCampaignsCampaignUidUnitsUnitUidRoute
  '/$org/settings/members/$userUid/sessions': typeof OrgSettingsMembersUserUidSessionsRoute
  '/$org/types/sync/runs/$runUid': typeof OrgTypesSyncRunsRunUidRoute
  '/c/$orgCode/$token_/viewings/$viewingUid': typeof COrgCodeTokenViewingsViewingUidRoute
  '/$org/types/sync/runs/': typeof OrgTypesSyncRunsIndexRoute
  '/$org/jobs/$jobUid/executions/$executionUid/': typeof OrgJobsJobUidExecutionsExecutionUidIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/$org'
    | '/login'
    | '/mfa-setup'
    | '/mfa-verify'
    | '/no-organization'
    | '/organizations'
    | '/$org/activity'
    | '/$org/assets'
    | '/$org/benchmark'
    | '/$org/business-rules'
    | '/$org/conversations'
    | '/$org/createBuilding'
    | '/$org/createBuildingGroup'
    | '/$org/data-protection'
    | '/$org/debug'
    | '/$org/design-reference'
    | '/$org/document-types'
    | '/$org/documents'
    | '/$org/graph'
    | '/$org/group'
    | '/$org/jobs'
    | '/$org/knowledge'
    | '/$org/login'
    | '/$org/password-reset'
    | '/$org/patterns'
    | '/$org/plan-rendering'
    | '/$org/reports'
    | '/$org/search'
    | '/$org/settings'
    | '/$org/sign-in-link'
    | '/$org/steering'
    | '/$org/test-crash'
    | '/$org/user'
    | '/about/$slug'
    | '/admin/proposed-rules'
    | '/admin/rent-indices'
    | '/impersonate/$token'
    | '/invitations/$token'
    | '/organizations/$orgCode'
    | '/q/$code'
    | '/s/$orgCode'
    | '/test/searcheable-select'
    | '/v/$orgCode'
    | '/$org/'
    | '/about/'
    | '/organizations/'
    | '/$org/agent-runs/$runUid'
    | '/$org/aggregations/$uid'
    | '/$org/assemblies/$uid'
    | '/$org/asset-types/$assetTypeUid'
    | '/$org/assets/$assetUid'
    | '/$org/assets/all'
    | '/$org/assets/createBasic'
    | '/$org/assets/old'
    | '/$org/campaigns/new'
    | '/$org/capex-plans/$planUid'
    | '/$org/compliance-controls/$controlUid'
    | '/$org/compliance-controls/create'
    | '/$org/compliance-rules/$ruleUid'
    | '/$org/compliance-rules/create'
    | '/$org/contract-stakeholder-types/$contractStakeholderTypeUid'
    | '/$org/contract-stakeholder-types/create'
    | '/$org/contract-types/$contractTypeUid'
    | '/$org/contract-types/create'
    | '/$org/contracts/$contractUid'
    | '/$org/contracts/create'
    | '/$org/contracts/timeline'
    | '/$org/conversations/intake-addresses'
    | '/$org/data/export'
    | '/$org/data/import'
    | '/$org/data/quality'
    | '/$org/debug/annotations'
    | '/$org/derivations/$uid'
    | '/$org/documents/$docUid'
    | '/$org/expenses/$expenseUid'
    | '/$org/expenses/statement'
    | '/$org/folder-layouts/$layoutUid'
    | '/$org/group/access'
    | '/$org/group/criteria'
    | '/$org/group/definitions'
    | '/$org/group/governance'
    | '/$org/group/perimeters'
    | '/$org/group/sites'
    | '/$org/imports/$importUid'
    | '/$org/interventions/$interventionUid'
    | '/$org/issues/$uid'
    | '/$org/jobs/$jobUid'
    | '/$org/jobs/blockers'
    | '/$org/labels/$code'
    | '/$org/listings/$listingUid'
    | '/$org/normalizations/$uid'
    | '/$org/properties/create'
    | '/$org/property-mapping-rules/$uid'
    | '/$org/relation-types/$relationTypeUid'
    | '/$org/relation-types/create'
    | '/$org/remediation-scenarios/$code'
    | '/$org/rental-applications/$applicationUid'
    | '/$org/rental-applications/viewings'
    | '/$org/settings/ai-models'
    | '/$org/settings/archive'
    | '/$org/signatures/$uid'
    | '/$org/tags/$tagCode'
    | '/$org/types/defaults'
    | '/$org/types/export'
    | '/$org/types/import'
    | '/$org/user/me'
    | '/$org/users/create'
    | '/$org/users/me'
    | '/admin/billing/$orgUid'
    | '/admin/billing/prices'
    | '/admin/billing/simulator'
    | '/c/$orgCode/$token'
    | '/r/$orgCode/$address'
    | '/test/bare/crash'
    | '/wo/$orgCode/$token'
    | '/$org/agent-runs/'
    | '/$org/aggregations/'
    | '/$org/assemblies/'
    | '/$org/asset-types/'
    | '/$org/assets/'
    | '/$org/campaigns/'
    | '/$org/capex-plans/'
    | '/$org/compliance-controls/'
    | '/$org/compliance-rules/'
    | '/$org/contract-stakeholder-types/'
    | '/$org/contract-types/'
    | '/$org/contracts/'
    | '/$org/data/'
    | '/$org/derivations/'
    | '/$org/documents/'
    | '/$org/expenses/'
    | '/$org/folder-layouts/'
    | '/$org/group/'
    | '/$org/imports/'
    | '/$org/interventions/'
    | '/$org/issues/'
    | '/$org/jobs/'
    | '/$org/leases/'
    | '/$org/listings/'
    | '/$org/normalizations/'
    | '/$org/properties/'
    | '/$org/property-mapping-rules/'
    | '/$org/relation-types/'
    | '/$org/remediation-scenarios/'
    | '/$org/rental-applications/'
    | '/$org/signatures/'
    | '/$org/tags/'
    | '/$org/types/'
    | '/$org/users/'
    | '/admin/agent-pool/'
    | '/admin/billing/'
    | '/admin/organizations/'
    | '/admin/settings/'
    | '/admin/usage/'
    | '/$org/assemblies/$uid/room'
    | '/$org/assets/$assetUid/edit'
    | '/$org/assets/$assetUid/plan-editor'
    | '/$org/campaigns/$campaignUid/edit'
    | '/$org/expenses/$expenseUid/edit'
    | '/$org/interventions/$interventionUid/edit'
    | '/$org/issues/$uid/edit'
    | '/$org/properties/$propertyUid/edit'
    | '/$org/settings/tags/$tagId'
    | '/$org/settings/webhooks/$subscriptionUid'
    | '/$org/types/thematics/$code'
    | '/$org/user/me/email-ingestion'
    | '/$org/user/me/notifications'
    | '/$org/user/me/passkeys'
    | '/$org/user/me/pat'
    | '/$org/user/me/profile'
    | '/$org/user/me/security'
    | '/$org/user/me/sessions'
    | '/$org/users/$userUid/settings'
    | '/$org/users/$userUid/tokens'
    | '/$org/users/me/settings'
    | '/admin/billing/invoices/$uid'
    | '/u/$orgCode/$token/unsubscribe'
    | '/$org/campaigns/$campaignUid/'
    | '/$org/properties/$propertyUid/'
    | '/$org/settings/billing/'
    | '/$org/settings/feature-flags/'
    | '/$org/settings/members/'
    | '/$org/settings/organization/'
    | '/$org/settings/roles/'
    | '/$org/settings/security/'
    | '/$org/settings/tags/'
    | '/$org/settings/webhooks/'
    | '/$org/types/sync/'
    | '/$org/types/thematics/'
    | '/$org/users/$userUid/'
    | '/admin/billing/invoices/'
    | '/$org/campaigns/$campaignUid/units/$unitUid'
    | '/$org/settings/members/$userUid/sessions'
    | '/$org/types/sync/runs/$runUid'
    | '/c/$orgCode/$token/viewings/$viewingUid'
    | '/$org/types/sync/runs/'
    | '/$org/jobs/$jobUid/executions/$executionUid/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/login'
    | '/mfa-setup'
    | '/mfa-verify'
    | '/no-organization'
    | '/$org/activity'
    | '/$org/benchmark'
    | '/$org/business-rules'
    | '/$org/conversations'
    | '/$org/createBuilding'
    | '/$org/createBuildingGroup'
    | '/$org/data-protection'
    | '/$org/debug'
    | '/$org/design-reference'
    | '/$org/document-types'
    | '/$org/graph'
    | '/$org/knowledge'
    | '/$org/login'
    | '/$org/password-reset'
    | '/$org/patterns'
    | '/$org/plan-rendering'
    | '/$org/reports'
    | '/$org/search'
    | '/$org/settings'
    | '/$org/sign-in-link'
    | '/$org/steering'
    | '/$org/test-crash'
    | '/$org/user'
    | '/about/$slug'
    | '/admin/proposed-rules'
    | '/admin/rent-indices'
    | '/impersonate/$token'
    | '/invitations/$token'
    | '/organizations/$orgCode'
    | '/q/$code'
    | '/s/$orgCode'
    | '/test/searcheable-select'
    | '/v/$orgCode'
    | '/$org'
    | '/about'
    | '/organizations'
    | '/$org/agent-runs/$runUid'
    | '/$org/aggregations/$uid'
    | '/$org/assemblies/$uid'
    | '/$org/asset-types/$assetTypeUid'
    | '/$org/assets/$assetUid'
    | '/$org/assets/all'
    | '/$org/assets/createBasic'
    | '/$org/assets/old'
    | '/$org/campaigns/new'
    | '/$org/capex-plans/$planUid'
    | '/$org/compliance-controls/$controlUid'
    | '/$org/compliance-controls/create'
    | '/$org/compliance-rules/$ruleUid'
    | '/$org/compliance-rules/create'
    | '/$org/contract-stakeholder-types/$contractStakeholderTypeUid'
    | '/$org/contract-stakeholder-types/create'
    | '/$org/contract-types/$contractTypeUid'
    | '/$org/contract-types/create'
    | '/$org/contracts/$contractUid'
    | '/$org/contracts/create'
    | '/$org/contracts/timeline'
    | '/$org/conversations/intake-addresses'
    | '/$org/data/export'
    | '/$org/data/import'
    | '/$org/data/quality'
    | '/$org/debug/annotations'
    | '/$org/derivations/$uid'
    | '/$org/documents/$docUid'
    | '/$org/expenses/$expenseUid'
    | '/$org/expenses/statement'
    | '/$org/folder-layouts/$layoutUid'
    | '/$org/group/access'
    | '/$org/group/criteria'
    | '/$org/group/definitions'
    | '/$org/group/governance'
    | '/$org/group/perimeters'
    | '/$org/group/sites'
    | '/$org/imports/$importUid'
    | '/$org/interventions/$interventionUid'
    | '/$org/issues/$uid'
    | '/$org/jobs/$jobUid'
    | '/$org/jobs/blockers'
    | '/$org/labels/$code'
    | '/$org/listings/$listingUid'
    | '/$org/normalizations/$uid'
    | '/$org/properties/create'
    | '/$org/property-mapping-rules/$uid'
    | '/$org/relation-types/$relationTypeUid'
    | '/$org/relation-types/create'
    | '/$org/remediation-scenarios/$code'
    | '/$org/rental-applications/$applicationUid'
    | '/$org/rental-applications/viewings'
    | '/$org/settings/ai-models'
    | '/$org/settings/archive'
    | '/$org/signatures/$uid'
    | '/$org/tags/$tagCode'
    | '/$org/types/defaults'
    | '/$org/types/export'
    | '/$org/types/import'
    | '/$org/user/me'
    | '/$org/users/create'
    | '/$org/users/me'
    | '/admin/billing/$orgUid'
    | '/admin/billing/prices'
    | '/admin/billing/simulator'
    | '/c/$orgCode/$token'
    | '/r/$orgCode/$address'
    | '/test/bare/crash'
    | '/wo/$orgCode/$token'
    | '/$org/agent-runs'
    | '/$org/aggregations'
    | '/$org/assemblies'
    | '/$org/asset-types'
    | '/$org/assets'
    | '/$org/campaigns'
    | '/$org/capex-plans'
    | '/$org/compliance-controls'
    | '/$org/compliance-rules'
    | '/$org/contract-stakeholder-types'
    | '/$org/contract-types'
    | '/$org/contracts'
    | '/$org/data'
    | '/$org/derivations'
    | '/$org/documents'
    | '/$org/expenses'
    | '/$org/folder-layouts'
    | '/$org/group'
    | '/$org/imports'
    | '/$org/interventions'
    | '/$org/issues'
    | '/$org/jobs'
    | '/$org/leases'
    | '/$org/listings'
    | '/$org/normalizations'
    | '/$org/properties'
    | '/$org/property-mapping-rules'
    | '/$org/relation-types'
    | '/$org/remediation-scenarios'
    | '/$org/rental-applications'
    | '/$org/signatures'
    | '/$org/tags'
    | '/$org/types'
    | '/$org/users'
    | '/admin/agent-pool'
    | '/admin/billing'
    | '/admin/organizations'
    | '/admin/settings'
    | '/admin/usage'
    | '/$org/assemblies/$uid/room'
    | '/$org/assets/$assetUid/edit'
    | '/$org/assets/$assetUid/plan-editor'
    | '/$org/campaigns/$campaignUid/edit'
    | '/$org/expenses/$expenseUid/edit'
    | '/$org/interventions/$interventionUid/edit'
    | '/$org/issues/$uid/edit'
    | '/$org/properties/$propertyUid/edit'
    | '/$org/settings/tags/$tagId'
    | '/$org/settings/webhooks/$subscriptionUid'
    | '/$org/types/thematics/$code'
    | '/$org/user/me/email-ingestion'
    | '/$org/user/me/notifications'
    | '/$org/user/me/passkeys'
    | '/$org/user/me/pat'
    | '/$org/user/me/profile'
    | '/$org/user/me/security'
    | '/$org/user/me/sessions'
    | '/$org/users/$userUid/settings'
    | '/$org/users/$userUid/tokens'
    | '/$org/users/me/settings'
    | '/admin/billing/invoices/$uid'
    | '/u/$orgCode/$token/unsubscribe'
    | '/$org/campaigns/$campaignUid'
    | '/$org/properties/$propertyUid'
    | '/$org/settings/billing'
    | '/$org/settings/feature-flags'
    | '/$org/settings/members'
    | '/$org/settings/organization'
    | '/$org/settings/roles'
    | '/$org/settings/security'
    | '/$org/settings/tags'
    | '/$org/settings/webhooks'
    | '/$org/types/sync'
    | '/$org/types/thematics'
    | '/$org/users/$userUid'
    | '/admin/billing/invoices'
    | '/$org/campaigns/$campaignUid/units/$unitUid'
    | '/$org/settings/members/$userUid/sessions'
    | '/$org/types/sync/runs/$runUid'
    | '/c/$orgCode/$token/viewings/$viewingUid'
    | '/$org/types/sync/runs'
    | '/$org/jobs/$jobUid/executions/$executionUid'
  id:
    | '__root__'
    | '/'
    | '/$org'
    | '/login'
    | '/mfa-setup'
    | '/mfa-verify'
    | '/no-organization'
    | '/organizations'
    | '/$org/activity'
    | '/$org/assets'
    | '/$org/benchmark'
    | '/$org/business-rules'
    | '/$org/conversations'
    | '/$org/createBuilding'
    | '/$org/createBuildingGroup'
    | '/$org/data-protection'
    | '/$org/debug'
    | '/$org/design-reference'
    | '/$org/document-types'
    | '/$org/documents'
    | '/$org/graph'
    | '/$org/group'
    | '/$org/jobs'
    | '/$org/knowledge'
    | '/$org/login'
    | '/$org/password-reset'
    | '/$org/patterns'
    | '/$org/plan-rendering'
    | '/$org/reports'
    | '/$org/search'
    | '/$org/settings'
    | '/$org/sign-in-link'
    | '/$org/steering'
    | '/$org/test-crash'
    | '/$org/user'
    | '/about/$slug'
    | '/admin/proposed-rules'
    | '/admin/rent-indices'
    | '/impersonate/$token'
    | '/invitations/$token'
    | '/organizations/$orgCode'
    | '/q/$code'
    | '/s/$orgCode'
    | '/test/searcheable-select'
    | '/v/$orgCode'
    | '/$org/'
    | '/about/'
    | '/organizations/'
    | '/$org/agent-runs/$runUid'
    | '/$org/aggregations/$uid'
    | '/$org/assemblies/$uid'
    | '/$org/asset-types/$assetTypeUid'
    | '/$org/assets/$assetUid'
    | '/$org/assets/all'
    | '/$org/assets/createBasic'
    | '/$org/assets/old'
    | '/$org/campaigns/new'
    | '/$org/capex-plans/$planUid'
    | '/$org/compliance-controls/$controlUid'
    | '/$org/compliance-controls/create'
    | '/$org/compliance-rules/$ruleUid'
    | '/$org/compliance-rules/create'
    | '/$org/contract-stakeholder-types/$contractStakeholderTypeUid'
    | '/$org/contract-stakeholder-types/create'
    | '/$org/contract-types/$contractTypeUid'
    | '/$org/contract-types/create'
    | '/$org/contracts/$contractUid'
    | '/$org/contracts/create'
    | '/$org/contracts/timeline'
    | '/$org/conversations_/intake-addresses'
    | '/$org/data/export'
    | '/$org/data/import'
    | '/$org/data/quality'
    | '/$org/debug_/annotations'
    | '/$org/derivations/$uid'
    | '/$org/documents/$docUid'
    | '/$org/expenses/$expenseUid'
    | '/$org/expenses/statement'
    | '/$org/folder-layouts/$layoutUid'
    | '/$org/group/access'
    | '/$org/group/criteria'
    | '/$org/group/definitions'
    | '/$org/group/governance'
    | '/$org/group/perimeters'
    | '/$org/group/sites'
    | '/$org/imports/$importUid'
    | '/$org/interventions/$interventionUid'
    | '/$org/issues/$uid'
    | '/$org/jobs/$jobUid'
    | '/$org/jobs/blockers'
    | '/$org/labels/$code'
    | '/$org/listings/$listingUid'
    | '/$org/normalizations/$uid'
    | '/$org/properties/create'
    | '/$org/property-mapping-rules/$uid'
    | '/$org/relation-types/$relationTypeUid'
    | '/$org/relation-types/create'
    | '/$org/remediation-scenarios/$code'
    | '/$org/rental-applications/$applicationUid'
    | '/$org/rental-applications/viewings'
    | '/$org/settings/ai-models'
    | '/$org/settings/archive'
    | '/$org/signatures/$uid'
    | '/$org/tags/$tagCode'
    | '/$org/types/defaults'
    | '/$org/types/export'
    | '/$org/types/import'
    | '/$org/user/me'
    | '/$org/users/create'
    | '/$org/users/me'
    | '/admin/billing/$orgUid'
    | '/admin/billing/prices'
    | '/admin/billing/simulator'
    | '/c/$orgCode/$token'
    | '/r/$orgCode/$address'
    | '/test/bare/crash'
    | '/wo/$orgCode/$token'
    | '/$org/agent-runs/'
    | '/$org/aggregations/'
    | '/$org/assemblies/'
    | '/$org/asset-types/'
    | '/$org/assets/'
    | '/$org/campaigns/'
    | '/$org/capex-plans/'
    | '/$org/compliance-controls/'
    | '/$org/compliance-rules/'
    | '/$org/contract-stakeholder-types/'
    | '/$org/contract-types/'
    | '/$org/contracts/'
    | '/$org/data/'
    | '/$org/derivations/'
    | '/$org/documents/'
    | '/$org/expenses/'
    | '/$org/folder-layouts/'
    | '/$org/group/'
    | '/$org/imports/'
    | '/$org/interventions/'
    | '/$org/issues/'
    | '/$org/jobs/'
    | '/$org/leases/'
    | '/$org/listings/'
    | '/$org/normalizations/'
    | '/$org/properties/'
    | '/$org/property-mapping-rules/'
    | '/$org/relation-types/'
    | '/$org/remediation-scenarios/'
    | '/$org/rental-applications/'
    | '/$org/signatures/'
    | '/$org/tags/'
    | '/$org/types/'
    | '/$org/users/'
    | '/admin/agent-pool/'
    | '/admin/billing/'
    | '/admin/organizations/'
    | '/admin/settings/'
    | '/admin/usage/'
    | '/$org/assemblies/$uid_/room'
    | '/$org/assets/$assetUid/edit'
    | '/$org/assets/$assetUid_/plan-editor'
    | '/$org/campaigns/$campaignUid/edit'
    | '/$org/expenses/$expenseUid/edit'
    | '/$org/interventions/$interventionUid/edit'
    | '/$org/issues/$uid/edit'
    | '/$org/properties/$propertyUid/edit'
    | '/$org/settings/tags/$tagId'
    | '/$org/settings/webhooks/$subscriptionUid'
    | '/$org/types/thematics/$code'
    | '/$org/user/me/email-ingestion'
    | '/$org/user/me/notifications'
    | '/$org/user/me/passkeys'
    | '/$org/user/me/pat'
    | '/$org/user/me/profile'
    | '/$org/user/me/security'
    | '/$org/user/me/sessions'
    | '/$org/users/$userUid/settings'
    | '/$org/users/$userUid/tokens'
    | '/$org/users/me/settings'
    | '/admin/billing/invoices/$uid'
    | '/u/$orgCode/$token/unsubscribe'
    | '/$org/campaigns/$campaignUid/'
    | '/$org/properties/$propertyUid/'
    | '/$org/settings/billing/'
    | '/$org/settings/feature-flags/'
    | '/$org/settings/members/'
    | '/$org/settings/organization/'
    | '/$org/settings/roles/'
    | '/$org/settings/security/'
    | '/$org/settings/tags/'
    | '/$org/settings/webhooks/'
    | '/$org/types/sync/'
    | '/$org/types/thematics/'
    | '/$org/users/$userUid/'
    | '/admin/billing/invoices/'
    | '/$org/campaigns/$campaignUid/units/$unitUid'
    | '/$org/settings/members/$userUid/sessions'
    | '/$org/types/sync/runs/$runUid'
    | '/c/$orgCode/$token_/viewings/$viewingUid'
    | '/$org/types/sync/runs/'
    | '/$org/jobs/$jobUid/executions/$executionUid/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  OrgRoute: typeof OrgRouteWithChildren
  LoginRoute: typeof LoginRoute
  MfaSetupRoute: typeof MfaSetupRoute
  MfaVerifyRoute: typeof MfaVerifyRoute
  NoOrganizationRoute: typeof NoOrganizationRoute
  OrganizationsRoute: typeof OrganizationsRouteWithChildren
  AboutSlugRoute: typeof AboutSlugRoute
  AdminProposedRulesRoute: typeof AdminProposedRulesRoute
  AdminRentIndicesRoute: typeof AdminRentIndicesRoute
  ImpersonateTokenRoute: typeof ImpersonateTokenRoute
  InvitationsTokenRoute: typeof InvitationsTokenRoute
  QCodeRoute: typeof QCodeRoute
  SOrgCodeRoute: typeof SOrgCodeRoute
  TestSearcheableSelectRoute: typeof TestSearcheableSelectRoute
  VOrgCodeRoute: typeof VOrgCodeRoute
  AboutIndexRoute: typeof AboutIndexRoute
  AdminBillingOrgUidRoute: typeof AdminBillingOrgUidRoute
  AdminBillingPricesRoute: typeof AdminBillingPricesRoute
  AdminBillingSimulatorRoute: typeof AdminBillingSimulatorRoute
  COrgCodeTokenRoute: typeof COrgCodeTokenRoute
  ROrgCodeAddressRoute: typeof ROrgCodeAddressRoute
  TestBareCrashRoute: typeof TestBareCrashRoute
  WoOrgCodeTokenRoute: typeof WoOrgCodeTokenRoute
  AdminAgentPoolIndexRoute: typeof AdminAgentPoolIndexRoute
  AdminBillingIndexRoute: typeof AdminBillingIndexRoute
  AdminOrganizationsIndexRoute: typeof AdminOrganizationsIndexRoute
  AdminSettingsIndexRoute: typeof AdminSettingsIndexRoute
  AdminUsageIndexRoute: typeof AdminUsageIndexRoute
  AdminBillingInvoicesUidRoute: typeof AdminBillingInvoicesUidRoute
  UOrgCodeTokenUnsubscribeRoute: typeof UOrgCodeTokenUnsubscribeRoute
  AdminBillingInvoicesIndexRoute: typeof AdminBillingInvoicesIndexRoute
  COrgCodeTokenViewingsViewingUidRoute: typeof COrgCodeTokenViewingsViewingUidRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org': {
      id: '/$org'
      path: '/$org'
      fullPath: '/$org'
      preLoaderRoute: typeof OrgRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa-setup': {
      id: '/mfa-setup'
      path: '/mfa-setup'
      fullPath: '/mfa-setup'
      preLoaderRoute: typeof MfaSetupRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/mfa-verify': {
      id: '/mfa-verify'
      path: '/mfa-verify'
      fullPath: '/mfa-verify'
      preLoaderRoute: typeof MfaVerifyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/no-organization': {
      id: '/no-organization'
      path: '/no-organization'
      fullPath: '/no-organization'
      preLoaderRoute: typeof NoOrganizationRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations': {
      id: '/organizations'
      path: '/organizations'
      fullPath: '/organizations'
      preLoaderRoute: typeof OrganizationsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/': {
      id: '/$org/'
      path: '/'
      fullPath: '/$org/'
      preLoaderRoute: typeof OrgIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/activity': {
      id: '/$org/activity'
      path: '/activity'
      fullPath: '/$org/activity'
      preLoaderRoute: typeof OrgActivityRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/assets': {
      id: '/$org/assets'
      path: '/assets'
      fullPath: '/$org/assets'
      preLoaderRoute: typeof OrgAssetsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/benchmark': {
      id: '/$org/benchmark'
      path: '/benchmark'
      fullPath: '/$org/benchmark'
      preLoaderRoute: typeof OrgBenchmarkRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/business-rules': {
      id: '/$org/business-rules'
      path: '/business-rules'
      fullPath: '/$org/business-rules'
      preLoaderRoute: typeof OrgBusinessRulesRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/conversations': {
      id: '/$org/conversations'
      path: '/conversations'
      fullPath: '/$org/conversations'
      preLoaderRoute: typeof OrgConversationsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/createBuilding': {
      id: '/$org/createBuilding'
      path: '/createBuilding'
      fullPath: '/$org/createBuilding'
      preLoaderRoute: typeof OrgCreateBuildingRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/createBuildingGroup': {
      id: '/$org/createBuildingGroup'
      path: '/createBuildingGroup'
      fullPath: '/$org/createBuildingGroup'
      preLoaderRoute: typeof OrgCreateBuildingGroupRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/data-protection': {
      id: '/$org/data-protection'
      path: '/data-protection'
      fullPath: '/$org/data-protection'
      preLoaderRoute: typeof OrgDataProtectionRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/debug': {
      id: '/$org/debug'
      path: '/debug'
      fullPath: '/$org/debug'
      preLoaderRoute: typeof OrgDebugRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/design-reference': {
      id: '/$org/design-reference'
      path: '/design-reference'
      fullPath: '/$org/design-reference'
      preLoaderRoute: typeof OrgDesignReferenceRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/document-types': {
      id: '/$org/document-types'
      path: '/document-types'
      fullPath: '/$org/document-types'
      preLoaderRoute: typeof OrgDocumentTypesRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/documents': {
      id: '/$org/documents'
      path: '/documents'
      fullPath: '/$org/documents'
      preLoaderRoute: typeof OrgDocumentsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/graph': {
      id: '/$org/graph'
      path: '/graph'
      fullPath: '/$org/graph'
      preLoaderRoute: typeof OrgGraphRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/group': {
      id: '/$org/group'
      path: '/group'
      fullPath: '/$org/group'
      preLoaderRoute: typeof OrgGroupRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/jobs': {
      id: '/$org/jobs'
      path: '/jobs'
      fullPath: '/$org/jobs'
      preLoaderRoute: typeof OrgJobsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/knowledge': {
      id: '/$org/knowledge'
      path: '/knowledge'
      fullPath: '/$org/knowledge'
      preLoaderRoute: typeof OrgKnowledgeRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/login': {
      id: '/$org/login'
      path: '/login'
      fullPath: '/$org/login'
      preLoaderRoute: typeof OrgLoginRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/password-reset': {
      id: '/$org/password-reset'
      path: '/password-reset'
      fullPath: '/$org/password-reset'
      preLoaderRoute: typeof OrgPasswordResetRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/patterns': {
      id: '/$org/patterns'
      path: '/patterns'
      fullPath: '/$org/patterns'
      preLoaderRoute: typeof OrgPatternsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/plan-rendering': {
      id: '/$org/plan-rendering'
      path: '/plan-rendering'
      fullPath: '/$org/plan-rendering'
      preLoaderRoute: typeof OrgPlanRenderingRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/reports': {
      id: '/$org/reports'
      path: '/reports'
      fullPath: '/$org/reports'
      preLoaderRoute: typeof OrgReportsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/search': {
      id: '/$org/search'
      path: '/search'
      fullPath: '/$org/search'
      preLoaderRoute: typeof OrgSearchRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/settings': {
      id: '/$org/settings'
      path: '/settings'
      fullPath: '/$org/settings'
      preLoaderRoute: typeof OrgSettingsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/sign-in-link': {
      id: '/$org/sign-in-link'
      path: '/sign-in-link'
      fullPath: '/$org/sign-in-link'
      preLoaderRoute: typeof OrgSignInLinkRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/steering': {
      id: '/$org/steering'
      path: '/steering'
      fullPath: '/$org/steering'
      preLoaderRoute: typeof OrgSteeringRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/test-crash': {
      id: '/$org/test-crash'
      path: '/test-crash'
      fullPath: '/$org/test-crash'
      preLoaderRoute: typeof OrgTestCrashRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/user': {
      id: '/$org/user'
      path: '/user'
      fullPath: '/$org/user'
      preLoaderRoute: typeof OrgUserRouteImport
      parentRoute: typeof OrgRoute
    }
    '/about/': {
      id: '/about/'
      path: '/about'
      fullPath: '/about/'
      preLoaderRoute: typeof AboutIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about/$slug': {
      id: '/about/$slug'
      path: '/about/$slug'
      fullPath: '/about/$slug'
      preLoaderRoute: typeof AboutSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/proposed-rules': {
      id: '/admin/proposed-rules'
      path: '/admin/proposed-rules'
      fullPath: '/admin/proposed-rules'
      preLoaderRoute: typeof AdminProposedRulesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/rent-indices': {
      id: '/admin/rent-indices'
      path: '/admin/rent-indices'
      fullPath: '/admin/rent-indices'
      preLoaderRoute: typeof AdminRentIndicesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/impersonate/$token': {
      id: '/impersonate/$token'
      path: '/impersonate/$token'
      fullPath: '/impersonate/$token'
      preLoaderRoute: typeof ImpersonateTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/invitations/$token': {
      id: '/invitations/$token'
      path: '/invitations/$token'
      fullPath: '/invitations/$token'
      preLoaderRoute: typeof InvitationsTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organizations/': {
      id: '/organizations/'
      path: '/'
      fullPath: '/organizations/'
      preLoaderRoute: typeof OrganizationsIndexRouteImport
      parentRoute: typeof OrganizationsRoute
    }
    '/organizations/$orgCode': {
      id: '/organizations/$orgCode'
      path: '/$orgCode'
      fullPath: '/organizations/$orgCode'
      preLoaderRoute: typeof OrganizationsOrgCodeRouteImport
      parentRoute: typeof OrganizationsRoute
    }
    '/q/$code': {
      id: '/q/$code'
      path: '/q/$code'
      fullPath: '/q/$code'
      preLoaderRoute: typeof QCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/s/$orgCode': {
      id: '/s/$orgCode'
      path: '/s/$orgCode'
      fullPath: '/s/$orgCode'
      preLoaderRoute: typeof SOrgCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/searcheable-select': {
      id: '/test/searcheable-select'
      path: '/test/searcheable-select'
      fullPath: '/test/searcheable-select'
      preLoaderRoute: typeof TestSearcheableSelectRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/v/$orgCode': {
      id: '/v/$orgCode'
      path: '/v/$orgCode'
      fullPath: '/v/$orgCode'
      preLoaderRoute: typeof VOrgCodeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/agent-runs/': {
      id: '/$org/agent-runs/'
      path: '/agent-runs'
      fullPath: '/$org/agent-runs/'
      preLoaderRoute: typeof OrgAgentRunsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/agent-runs/$runUid': {
      id: '/$org/agent-runs/$runUid'
      path: '/agent-runs/$runUid'
      fullPath: '/$org/agent-runs/$runUid'
      preLoaderRoute: typeof OrgAgentRunsRunUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/aggregations/': {
      id: '/$org/aggregations/'
      path: '/aggregations'
      fullPath: '/$org/aggregations/'
      preLoaderRoute: typeof OrgAggregationsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/aggregations/$uid': {
      id: '/$org/aggregations/$uid'
      path: '/aggregations/$uid'
      fullPath: '/$org/aggregations/$uid'
      preLoaderRoute: typeof OrgAggregationsUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/assemblies/': {
      id: '/$org/assemblies/'
      path: '/assemblies'
      fullPath: '/$org/assemblies/'
      preLoaderRoute: typeof OrgAssembliesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/assemblies/$uid': {
      id: '/$org/assemblies/$uid'
      path: '/assemblies/$uid'
      fullPath: '/$org/assemblies/$uid'
      preLoaderRoute: typeof OrgAssembliesUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/asset-types/': {
      id: '/$org/asset-types/'
      path: '/asset-types'
      fullPath: '/$org/asset-types/'
      preLoaderRoute: typeof OrgAssetTypesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/asset-types/$assetTypeUid': {
      id: '/$org/asset-types/$assetTypeUid'
      path: '/asset-types/$assetTypeUid'
      fullPath: '/$org/asset-types/$assetTypeUid'
      preLoaderRoute: typeof OrgAssetTypesAssetTypeUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/assets/': {
      id: '/$org/assets/'
      path: '/'
      fullPath: '/$org/assets/'
      preLoaderRoute: typeof OrgAssetsIndexRouteImport
      parentRoute: typeof OrgAssetsRoute
    }
    '/$org/assets/$assetUid': {
      id: '/$org/assets/$assetUid'
      path: '/$assetUid'
      fullPath: '/$org/assets/$assetUid'
      preLoaderRoute: typeof OrgAssetsAssetUidRouteImport
      parentRoute: typeof OrgAssetsRoute
    }
    '/$org/assets/all': {
      id: '/$org/assets/all'
      path: '/all'
      fullPath: '/$org/assets/all'
      preLoaderRoute: typeof OrgAssetsAllRouteImport
      parentRoute: typeof OrgAssetsRoute
    }
    '/$org/assets/createBasic': {
      id: '/$org/assets/createBasic'
      path: '/createBasic'
      fullPath: '/$org/assets/createBasic'
      preLoaderRoute: typeof OrgAssetsCreateBasicRouteImport
      parentRoute: typeof OrgAssetsRoute
    }
    '/$org/assets/old': {
      id: '/$org/assets/old'
      path: '/old'
      fullPath: '/$org/assets/old'
      preLoaderRoute: typeof OrgAssetsOldRouteImport
      parentRoute: typeof OrgAssetsRoute
    }
    '/$org/campaigns/': {
      id: '/$org/campaigns/'
      path: '/campaigns'
      fullPath: '/$org/campaigns/'
      preLoaderRoute: typeof OrgCampaignsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/campaigns/new': {
      id: '/$org/campaigns/new'
      path: '/campaigns/new'
      fullPath: '/$org/campaigns/new'
      preLoaderRoute: typeof OrgCampaignsNewRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/capex-plans/': {
      id: '/$org/capex-plans/'
      path: '/capex-plans'
      fullPath: '/$org/capex-plans/'
      preLoaderRoute: typeof OrgCapexPlansIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/capex-plans/$planUid': {
      id: '/$org/capex-plans/$planUid'
      path: '/capex-plans/$planUid'
      fullPath: '/$org/capex-plans/$planUid'
      preLoaderRoute: typeof OrgCapexPlansPlanUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/compliance-controls/': {
      id: '/$org/compliance-controls/'
      path: '/compliance-controls'
      fullPath: '/$org/compliance-controls/'
      preLoaderRoute: typeof OrgComplianceControlsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/compliance-controls/$controlUid': {
      id: '/$org/compliance-controls/$controlUid'
      path: '/compliance-controls/$controlUid'
      fullPath: '/$org/compliance-controls/$controlUid'
      preLoaderRoute: typeof OrgComplianceControlsControlUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/compliance-controls/create': {
      id: '/$org/compliance-controls/create'
      path: '/compliance-controls/create'
      fullPath: '/$org/compliance-controls/create'
      preLoaderRoute: typeof OrgComplianceControlsCreateRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/compliance-rules/': {
      id: '/$org/compliance-rules/'
      path: '/compliance-rules'
      fullPath: '/$org/compliance-rules/'
      preLoaderRoute: typeof OrgComplianceRulesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/compliance-rules/$ruleUid': {
      id: '/$org/compliance-rules/$ruleUid'
      path: '/compliance-rules/$ruleUid'
      fullPath: '/$org/compliance-rules/$ruleUid'
      preLoaderRoute: typeof OrgComplianceRulesRuleUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/compliance-rules/create': {
      id: '/$org/compliance-rules/create'
      path: '/compliance-rules/create'
      fullPath: '/$org/compliance-rules/create'
      preLoaderRoute: typeof OrgComplianceRulesCreateRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contract-stakeholder-types/': {
      id: '/$org/contract-stakeholder-types/'
      path: '/contract-stakeholder-types'
      fullPath: '/$org/contract-stakeholder-types/'
      preLoaderRoute: typeof OrgContractStakeholderTypesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contract-stakeholder-types/$contractStakeholderTypeUid': {
      id: '/$org/contract-stakeholder-types/$contractStakeholderTypeUid'
      path: '/contract-stakeholder-types/$contractStakeholderTypeUid'
      fullPath: '/$org/contract-stakeholder-types/$contractStakeholderTypeUid'
      preLoaderRoute: typeof OrgContractStakeholderTypesContractStakeholderTypeUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contract-stakeholder-types/create': {
      id: '/$org/contract-stakeholder-types/create'
      path: '/contract-stakeholder-types/create'
      fullPath: '/$org/contract-stakeholder-types/create'
      preLoaderRoute: typeof OrgContractStakeholderTypesCreateRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contract-types/': {
      id: '/$org/contract-types/'
      path: '/contract-types'
      fullPath: '/$org/contract-types/'
      preLoaderRoute: typeof OrgContractTypesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contract-types/$contractTypeUid': {
      id: '/$org/contract-types/$contractTypeUid'
      path: '/contract-types/$contractTypeUid'
      fullPath: '/$org/contract-types/$contractTypeUid'
      preLoaderRoute: typeof OrgContractTypesContractTypeUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contract-types/create': {
      id: '/$org/contract-types/create'
      path: '/contract-types/create'
      fullPath: '/$org/contract-types/create'
      preLoaderRoute: typeof OrgContractTypesCreateRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contracts/': {
      id: '/$org/contracts/'
      path: '/contracts'
      fullPath: '/$org/contracts/'
      preLoaderRoute: typeof OrgContractsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contracts/$contractUid': {
      id: '/$org/contracts/$contractUid'
      path: '/contracts/$contractUid'
      fullPath: '/$org/contracts/$contractUid'
      preLoaderRoute: typeof OrgContractsContractUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contracts/create': {
      id: '/$org/contracts/create'
      path: '/contracts/create'
      fullPath: '/$org/contracts/create'
      preLoaderRoute: typeof OrgContractsCreateRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/contracts/timeline': {
      id: '/$org/contracts/timeline'
      path: '/contracts/timeline'
      fullPath: '/$org/contracts/timeline'
      preLoaderRoute: typeof OrgContractsTimelineRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/conversations_/intake-addresses': {
      id: '/$org/conversations_/intake-addresses'
      path: '/conversations/intake-addresses'
      fullPath: '/$org/conversations/intake-addresses'
      preLoaderRoute: typeof OrgConversationsIntakeAddressesRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/data/': {
      id: '/$org/data/'
      path: '/data'
      fullPath: '/$org/data/'
      preLoaderRoute: typeof OrgDataIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/data/export': {
      id: '/$org/data/export'
      path: '/data/export'
      fullPath: '/$org/data/export'
      preLoaderRoute: typeof OrgDataExportRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/data/import': {
      id: '/$org/data/import'
      path: '/data/import'
      fullPath: '/$org/data/import'
      preLoaderRoute: typeof OrgDataImportRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/data/quality': {
      id: '/$org/data/quality'
      path: '/data/quality'
      fullPath: '/$org/data/quality'
      preLoaderRoute: typeof OrgDataQualityRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/debug_/annotations': {
      id: '/$org/debug_/annotations'
      path: '/debug/annotations'
      fullPath: '/$org/debug/annotations'
      preLoaderRoute: typeof OrgDebugAnnotationsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/derivations/': {
      id: '/$org/derivations/'
      path: '/derivations'
      fullPath: '/$org/derivations/'
      preLoaderRoute: typeof OrgDerivationsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/derivations/$uid': {
      id: '/$org/derivations/$uid'
      path: '/derivations/$uid'
      fullPath: '/$org/derivations/$uid'
      preLoaderRoute: typeof OrgDerivationsUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/documents/': {
      id: '/$org/documents/'
      path: '/'
      fullPath: '/$org/documents/'
      preLoaderRoute: typeof OrgDocumentsIndexRouteImport
      parentRoute: typeof OrgDocumentsRoute
    }
    '/$org/documents/$docUid': {
      id: '/$org/documents/$docUid'
      path: '/$docUid'
      fullPath: '/$org/documents/$docUid'
      preLoaderRoute: typeof OrgDocumentsDocUidRouteImport
      parentRoute: typeof OrgDocumentsRoute
    }
    '/$org/expenses/': {
      id: '/$org/expenses/'
      path: '/expenses'
      fullPath: '/$org/expenses/'
      preLoaderRoute: typeof OrgExpensesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/expenses/$expenseUid': {
      id: '/$org/expenses/$expenseUid'
      path: '/expenses/$expenseUid'
      fullPath: '/$org/expenses/$expenseUid'
      preLoaderRoute: typeof OrgExpensesExpenseUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/expenses/statement': {
      id: '/$org/expenses/statement'
      path: '/expenses/statement'
      fullPath: '/$org/expenses/statement'
      preLoaderRoute: typeof OrgExpensesStatementRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/folder-layouts/': {
      id: '/$org/folder-layouts/'
      path: '/folder-layouts'
      fullPath: '/$org/folder-layouts/'
      preLoaderRoute: typeof OrgFolderLayoutsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/folder-layouts/$layoutUid': {
      id: '/$org/folder-layouts/$layoutUid'
      path: '/folder-layouts/$layoutUid'
      fullPath: '/$org/folder-layouts/$layoutUid'
      preLoaderRoute: typeof OrgFolderLayoutsLayoutUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/group/': {
      id: '/$org/group/'
      path: '/'
      fullPath: '/$org/group/'
      preLoaderRoute: typeof OrgGroupIndexRouteImport
      parentRoute: typeof OrgGroupRoute
    }
    '/$org/group/access': {
      id: '/$org/group/access'
      path: '/access'
      fullPath: '/$org/group/access'
      preLoaderRoute: typeof OrgGroupAccessRouteImport
      parentRoute: typeof OrgGroupRoute
    }
    '/$org/group/criteria': {
      id: '/$org/group/criteria'
      path: '/criteria'
      fullPath: '/$org/group/criteria'
      preLoaderRoute: typeof OrgGroupCriteriaRouteImport
      parentRoute: typeof OrgGroupRoute
    }
    '/$org/group/definitions': {
      id: '/$org/group/definitions'
      path: '/definitions'
      fullPath: '/$org/group/definitions'
      preLoaderRoute: typeof OrgGroupDefinitionsRouteImport
      parentRoute: typeof OrgGroupRoute
    }
    '/$org/group/governance': {
      id: '/$org/group/governance'
      path: '/governance'
      fullPath: '/$org/group/governance'
      preLoaderRoute: typeof OrgGroupGovernanceRouteImport
      parentRoute: typeof OrgGroupRoute
    }
    '/$org/group/perimeters': {
      id: '/$org/group/perimeters'
      path: '/perimeters'
      fullPath: '/$org/group/perimeters'
      preLoaderRoute: typeof OrgGroupPerimetersRouteImport
      parentRoute: typeof OrgGroupRoute
    }
    '/$org/group/sites': {
      id: '/$org/group/sites'
      path: '/sites'
      fullPath: '/$org/group/sites'
      preLoaderRoute: typeof OrgGroupSitesRouteImport
      parentRoute: typeof OrgGroupRoute
    }
    '/$org/imports/': {
      id: '/$org/imports/'
      path: '/imports'
      fullPath: '/$org/imports/'
      preLoaderRoute: typeof OrgImportsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/imports/$importUid': {
      id: '/$org/imports/$importUid'
      path: '/imports/$importUid'
      fullPath: '/$org/imports/$importUid'
      preLoaderRoute: typeof OrgImportsImportUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/interventions/': {
      id: '/$org/interventions/'
      path: '/interventions'
      fullPath: '/$org/interventions/'
      preLoaderRoute: typeof OrgInterventionsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/interventions/$interventionUid': {
      id: '/$org/interventions/$interventionUid'
      path: '/interventions/$interventionUid'
      fullPath: '/$org/interventions/$interventionUid'
      preLoaderRoute: typeof OrgInterventionsInterventionUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/issues/': {
      id: '/$org/issues/'
      path: '/issues'
      fullPath: '/$org/issues/'
      preLoaderRoute: typeof OrgIssuesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/issues/$uid': {
      id: '/$org/issues/$uid'
      path: '/issues/$uid'
      fullPath: '/$org/issues/$uid'
      preLoaderRoute: typeof OrgIssuesUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/jobs/': {
      id: '/$org/jobs/'
      path: '/'
      fullPath: '/$org/jobs/'
      preLoaderRoute: typeof OrgJobsIndexRouteImport
      parentRoute: typeof OrgJobsRoute
    }
    '/$org/jobs/$jobUid': {
      id: '/$org/jobs/$jobUid'
      path: '/$jobUid'
      fullPath: '/$org/jobs/$jobUid'
      preLoaderRoute: typeof OrgJobsJobUidRouteImport
      parentRoute: typeof OrgJobsRoute
    }
    '/$org/jobs/blockers': {
      id: '/$org/jobs/blockers'
      path: '/blockers'
      fullPath: '/$org/jobs/blockers'
      preLoaderRoute: typeof OrgJobsBlockersRouteImport
      parentRoute: typeof OrgJobsRoute
    }
    '/$org/labels/$code': {
      id: '/$org/labels/$code'
      path: '/labels/$code'
      fullPath: '/$org/labels/$code'
      preLoaderRoute: typeof OrgLabelsCodeRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/leases/': {
      id: '/$org/leases/'
      path: '/leases'
      fullPath: '/$org/leases/'
      preLoaderRoute: typeof OrgLeasesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/listings/': {
      id: '/$org/listings/'
      path: '/listings'
      fullPath: '/$org/listings/'
      preLoaderRoute: typeof OrgListingsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/listings/$listingUid': {
      id: '/$org/listings/$listingUid'
      path: '/listings/$listingUid'
      fullPath: '/$org/listings/$listingUid'
      preLoaderRoute: typeof OrgListingsListingUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/normalizations/': {
      id: '/$org/normalizations/'
      path: '/normalizations'
      fullPath: '/$org/normalizations/'
      preLoaderRoute: typeof OrgNormalizationsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/normalizations/$uid': {
      id: '/$org/normalizations/$uid'
      path: '/normalizations/$uid'
      fullPath: '/$org/normalizations/$uid'
      preLoaderRoute: typeof OrgNormalizationsUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/properties/': {
      id: '/$org/properties/'
      path: '/properties'
      fullPath: '/$org/properties/'
      preLoaderRoute: typeof OrgPropertiesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/properties/create': {
      id: '/$org/properties/create'
      path: '/properties/create'
      fullPath: '/$org/properties/create'
      preLoaderRoute: typeof OrgPropertiesCreateRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/property-mapping-rules/': {
      id: '/$org/property-mapping-rules/'
      path: '/property-mapping-rules'
      fullPath: '/$org/property-mapping-rules/'
      preLoaderRoute: typeof OrgPropertyMappingRulesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/property-mapping-rules/$uid': {
      id: '/$org/property-mapping-rules/$uid'
      path: '/property-mapping-rules/$uid'
      fullPath: '/$org/property-mapping-rules/$uid'
      preLoaderRoute: typeof OrgPropertyMappingRulesUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/relation-types/': {
      id: '/$org/relation-types/'
      path: '/relation-types'
      fullPath: '/$org/relation-types/'
      preLoaderRoute: typeof OrgRelationTypesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/relation-types/$relationTypeUid': {
      id: '/$org/relation-types/$relationTypeUid'
      path: '/relation-types/$relationTypeUid'
      fullPath: '/$org/relation-types/$relationTypeUid'
      preLoaderRoute: typeof OrgRelationTypesRelationTypeUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/relation-types/create': {
      id: '/$org/relation-types/create'
      path: '/relation-types/create'
      fullPath: '/$org/relation-types/create'
      preLoaderRoute: typeof OrgRelationTypesCreateRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/remediation-scenarios/': {
      id: '/$org/remediation-scenarios/'
      path: '/remediation-scenarios'
      fullPath: '/$org/remediation-scenarios/'
      preLoaderRoute: typeof OrgRemediationScenariosIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/remediation-scenarios/$code': {
      id: '/$org/remediation-scenarios/$code'
      path: '/remediation-scenarios/$code'
      fullPath: '/$org/remediation-scenarios/$code'
      preLoaderRoute: typeof OrgRemediationScenariosCodeRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/rental-applications/': {
      id: '/$org/rental-applications/'
      path: '/rental-applications'
      fullPath: '/$org/rental-applications/'
      preLoaderRoute: typeof OrgRentalApplicationsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/rental-applications/$applicationUid': {
      id: '/$org/rental-applications/$applicationUid'
      path: '/rental-applications/$applicationUid'
      fullPath: '/$org/rental-applications/$applicationUid'
      preLoaderRoute: typeof OrgRentalApplicationsApplicationUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/rental-applications/viewings': {
      id: '/$org/rental-applications/viewings'
      path: '/rental-applications/viewings'
      fullPath: '/$org/rental-applications/viewings'
      preLoaderRoute: typeof OrgRentalApplicationsViewingsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/settings/ai-models': {
      id: '/$org/settings/ai-models'
      path: '/ai-models'
      fullPath: '/$org/settings/ai-models'
      preLoaderRoute: typeof OrgSettingsAiModelsRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/archive': {
      id: '/$org/settings/archive'
      path: '/archive'
      fullPath: '/$org/settings/archive'
      preLoaderRoute: typeof OrgSettingsArchiveRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/signatures/': {
      id: '/$org/signatures/'
      path: '/signatures'
      fullPath: '/$org/signatures/'
      preLoaderRoute: typeof OrgSignaturesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/signatures/$uid': {
      id: '/$org/signatures/$uid'
      path: '/signatures/$uid'
      fullPath: '/$org/signatures/$uid'
      preLoaderRoute: typeof OrgSignaturesUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/tags/': {
      id: '/$org/tags/'
      path: '/tags'
      fullPath: '/$org/tags/'
      preLoaderRoute: typeof OrgTagsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/tags/$tagCode': {
      id: '/$org/tags/$tagCode'
      path: '/tags/$tagCode'
      fullPath: '/$org/tags/$tagCode'
      preLoaderRoute: typeof OrgTagsTagCodeRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/types/': {
      id: '/$org/types/'
      path: '/types'
      fullPath: '/$org/types/'
      preLoaderRoute: typeof OrgTypesIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/types/defaults': {
      id: '/$org/types/defaults'
      path: '/types/defaults'
      fullPath: '/$org/types/defaults'
      preLoaderRoute: typeof OrgTypesDefaultsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/types/export': {
      id: '/$org/types/export'
      path: '/types/export'
      fullPath: '/$org/types/export'
      preLoaderRoute: typeof OrgTypesExportRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/types/import': {
      id: '/$org/types/import'
      path: '/types/import'
      fullPath: '/$org/types/import'
      preLoaderRoute: typeof OrgTypesImportRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/user/me': {
      id: '/$org/user/me'
      path: '/me'
      fullPath: '/$org/user/me'
      preLoaderRoute: typeof OrgUserMeRouteImport
      parentRoute: typeof OrgUserRoute
    }
    '/$org/users/': {
      id: '/$org/users/'
      path: '/users'
      fullPath: '/$org/users/'
      preLoaderRoute: typeof OrgUsersIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/users/create': {
      id: '/$org/users/create'
      path: '/users/create'
      fullPath: '/$org/users/create'
      preLoaderRoute: typeof OrgUsersCreateRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/users/me': {
      id: '/$org/users/me'
      path: '/users/me'
      fullPath: '/$org/users/me'
      preLoaderRoute: typeof OrgUsersMeRouteImport
      parentRoute: typeof OrgRoute
    }
    '/admin/agent-pool/': {
      id: '/admin/agent-pool/'
      path: '/admin/agent-pool'
      fullPath: '/admin/agent-pool/'
      preLoaderRoute: typeof AdminAgentPoolIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing/': {
      id: '/admin/billing/'
      path: '/admin/billing'
      fullPath: '/admin/billing/'
      preLoaderRoute: typeof AdminBillingIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing/$orgUid': {
      id: '/admin/billing/$orgUid'
      path: '/admin/billing/$orgUid'
      fullPath: '/admin/billing/$orgUid'
      preLoaderRoute: typeof AdminBillingOrgUidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing/prices': {
      id: '/admin/billing/prices'
      path: '/admin/billing/prices'
      fullPath: '/admin/billing/prices'
      preLoaderRoute: typeof AdminBillingPricesRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing/simulator': {
      id: '/admin/billing/simulator'
      path: '/admin/billing/simulator'
      fullPath: '/admin/billing/simulator'
      preLoaderRoute: typeof AdminBillingSimulatorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/organizations/': {
      id: '/admin/organizations/'
      path: '/admin/organizations'
      fullPath: '/admin/organizations/'
      preLoaderRoute: typeof AdminOrganizationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/settings/': {
      id: '/admin/settings/'
      path: '/admin/settings'
      fullPath: '/admin/settings/'
      preLoaderRoute: typeof AdminSettingsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/usage/': {
      id: '/admin/usage/'
      path: '/admin/usage'
      fullPath: '/admin/usage/'
      preLoaderRoute: typeof AdminUsageIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/c/$orgCode/$token': {
      id: '/c/$orgCode/$token'
      path: '/c/$orgCode/$token'
      fullPath: '/c/$orgCode/$token'
      preLoaderRoute: typeof COrgCodeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/r/$orgCode/$address': {
      id: '/r/$orgCode/$address'
      path: '/r/$orgCode/$address'
      fullPath: '/r/$orgCode/$address'
      preLoaderRoute: typeof ROrgCodeAddressRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/test/bare/crash': {
      id: '/test/bare/crash'
      path: '/test/bare/crash'
      fullPath: '/test/bare/crash'
      preLoaderRoute: typeof TestBareCrashRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/wo/$orgCode/$token': {
      id: '/wo/$orgCode/$token'
      path: '/wo/$orgCode/$token'
      fullPath: '/wo/$orgCode/$token'
      preLoaderRoute: typeof WoOrgCodeTokenRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/assemblies/$uid_/room': {
      id: '/$org/assemblies/$uid_/room'
      path: '/assemblies/$uid/room'
      fullPath: '/$org/assemblies/$uid/room'
      preLoaderRoute: typeof OrgAssembliesUidRoomRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/assets/$assetUid/edit': {
      id: '/$org/assets/$assetUid/edit'
      path: '/edit'
      fullPath: '/$org/assets/$assetUid/edit'
      preLoaderRoute: typeof OrgAssetsAssetUidEditRouteImport
      parentRoute: typeof OrgAssetsAssetUidRoute
    }
    '/$org/assets/$assetUid_/plan-editor': {
      id: '/$org/assets/$assetUid_/plan-editor'
      path: '/$assetUid/plan-editor'
      fullPath: '/$org/assets/$assetUid/plan-editor'
      preLoaderRoute: typeof OrgAssetsAssetUidPlanEditorRouteImport
      parentRoute: typeof OrgAssetsRoute
    }
    '/$org/campaigns/$campaignUid/': {
      id: '/$org/campaigns/$campaignUid/'
      path: '/campaigns/$campaignUid'
      fullPath: '/$org/campaigns/$campaignUid/'
      preLoaderRoute: typeof OrgCampaignsCampaignUidIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/campaigns/$campaignUid/edit': {
      id: '/$org/campaigns/$campaignUid/edit'
      path: '/campaigns/$campaignUid/edit'
      fullPath: '/$org/campaigns/$campaignUid/edit'
      preLoaderRoute: typeof OrgCampaignsCampaignUidEditRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/expenses/$expenseUid/edit': {
      id: '/$org/expenses/$expenseUid/edit'
      path: '/edit'
      fullPath: '/$org/expenses/$expenseUid/edit'
      preLoaderRoute: typeof OrgExpensesExpenseUidEditRouteImport
      parentRoute: typeof OrgExpensesExpenseUidRoute
    }
    '/$org/interventions/$interventionUid/edit': {
      id: '/$org/interventions/$interventionUid/edit'
      path: '/edit'
      fullPath: '/$org/interventions/$interventionUid/edit'
      preLoaderRoute: typeof OrgInterventionsInterventionUidEditRouteImport
      parentRoute: typeof OrgInterventionsInterventionUidRoute
    }
    '/$org/issues/$uid/edit': {
      id: '/$org/issues/$uid/edit'
      path: '/edit'
      fullPath: '/$org/issues/$uid/edit'
      preLoaderRoute: typeof OrgIssuesUidEditRouteImport
      parentRoute: typeof OrgIssuesUidRoute
    }
    '/$org/properties/$propertyUid/': {
      id: '/$org/properties/$propertyUid/'
      path: '/properties/$propertyUid'
      fullPath: '/$org/properties/$propertyUid/'
      preLoaderRoute: typeof OrgPropertiesPropertyUidIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/properties/$propertyUid/edit': {
      id: '/$org/properties/$propertyUid/edit'
      path: '/properties/$propertyUid/edit'
      fullPath: '/$org/properties/$propertyUid/edit'
      preLoaderRoute: typeof OrgPropertiesPropertyUidEditRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/settings/billing/': {
      id: '/$org/settings/billing/'
      path: '/billing'
      fullPath: '/$org/settings/billing/'
      preLoaderRoute: typeof OrgSettingsBillingIndexRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/feature-flags/': {
      id: '/$org/settings/feature-flags/'
      path: '/feature-flags'
      fullPath: '/$org/settings/feature-flags/'
      preLoaderRoute: typeof OrgSettingsFeatureFlagsIndexRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/members/': {
      id: '/$org/settings/members/'
      path: '/members'
      fullPath: '/$org/settings/members/'
      preLoaderRoute: typeof OrgSettingsMembersIndexRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/organization/': {
      id: '/$org/settings/organization/'
      path: '/organization'
      fullPath: '/$org/settings/organization/'
      preLoaderRoute: typeof OrgSettingsOrganizationIndexRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/roles/': {
      id: '/$org/settings/roles/'
      path: '/roles'
      fullPath: '/$org/settings/roles/'
      preLoaderRoute: typeof OrgSettingsRolesIndexRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/security/': {
      id: '/$org/settings/security/'
      path: '/security'
      fullPath: '/$org/settings/security/'
      preLoaderRoute: typeof OrgSettingsSecurityIndexRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/tags/': {
      id: '/$org/settings/tags/'
      path: '/tags'
      fullPath: '/$org/settings/tags/'
      preLoaderRoute: typeof OrgSettingsTagsIndexRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/tags/$tagId': {
      id: '/$org/settings/tags/$tagId'
      path: '/tags/$tagId'
      fullPath: '/$org/settings/tags/$tagId'
      preLoaderRoute: typeof OrgSettingsTagsTagIdRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/webhooks/': {
      id: '/$org/settings/webhooks/'
      path: '/webhooks'
      fullPath: '/$org/settings/webhooks/'
      preLoaderRoute: typeof OrgSettingsWebhooksIndexRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/settings/webhooks/$subscriptionUid': {
      id: '/$org/settings/webhooks/$subscriptionUid'
      path: '/webhooks/$subscriptionUid'
      fullPath: '/$org/settings/webhooks/$subscriptionUid'
      preLoaderRoute: typeof OrgSettingsWebhooksSubscriptionUidRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/types/sync/': {
      id: '/$org/types/sync/'
      path: '/types/sync'
      fullPath: '/$org/types/sync/'
      preLoaderRoute: typeof OrgTypesSyncIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/types/thematics/': {
      id: '/$org/types/thematics/'
      path: '/types/thematics'
      fullPath: '/$org/types/thematics/'
      preLoaderRoute: typeof OrgTypesThematicsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/types/thematics/$code': {
      id: '/$org/types/thematics/$code'
      path: '/types/thematics/$code'
      fullPath: '/$org/types/thematics/$code'
      preLoaderRoute: typeof OrgTypesThematicsCodeRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/user/me/email-ingestion': {
      id: '/$org/user/me/email-ingestion'
      path: '/email-ingestion'
      fullPath: '/$org/user/me/email-ingestion'
      preLoaderRoute: typeof OrgUserMeEmailIngestionRouteImport
      parentRoute: typeof OrgUserMeRoute
    }
    '/$org/user/me/notifications': {
      id: '/$org/user/me/notifications'
      path: '/notifications'
      fullPath: '/$org/user/me/notifications'
      preLoaderRoute: typeof OrgUserMeNotificationsRouteImport
      parentRoute: typeof OrgUserMeRoute
    }
    '/$org/user/me/passkeys': {
      id: '/$org/user/me/passkeys'
      path: '/passkeys'
      fullPath: '/$org/user/me/passkeys'
      preLoaderRoute: typeof OrgUserMePasskeysRouteImport
      parentRoute: typeof OrgUserMeRoute
    }
    '/$org/user/me/pat': {
      id: '/$org/user/me/pat'
      path: '/pat'
      fullPath: '/$org/user/me/pat'
      preLoaderRoute: typeof OrgUserMePatRouteImport
      parentRoute: typeof OrgUserMeRoute
    }
    '/$org/user/me/profile': {
      id: '/$org/user/me/profile'
      path: '/profile'
      fullPath: '/$org/user/me/profile'
      preLoaderRoute: typeof OrgUserMeProfileRouteImport
      parentRoute: typeof OrgUserMeRoute
    }
    '/$org/user/me/security': {
      id: '/$org/user/me/security'
      path: '/security'
      fullPath: '/$org/user/me/security'
      preLoaderRoute: typeof OrgUserMeSecurityRouteImport
      parentRoute: typeof OrgUserMeRoute
    }
    '/$org/user/me/sessions': {
      id: '/$org/user/me/sessions'
      path: '/sessions'
      fullPath: '/$org/user/me/sessions'
      preLoaderRoute: typeof OrgUserMeSessionsRouteImport
      parentRoute: typeof OrgUserMeRoute
    }
    '/$org/users/$userUid/': {
      id: '/$org/users/$userUid/'
      path: '/users/$userUid'
      fullPath: '/$org/users/$userUid/'
      preLoaderRoute: typeof OrgUsersUserUidIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/users/$userUid/settings': {
      id: '/$org/users/$userUid/settings'
      path: '/users/$userUid/settings'
      fullPath: '/$org/users/$userUid/settings'
      preLoaderRoute: typeof OrgUsersUserUidSettingsRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/users/$userUid/tokens': {
      id: '/$org/users/$userUid/tokens'
      path: '/users/$userUid/tokens'
      fullPath: '/$org/users/$userUid/tokens'
      preLoaderRoute: typeof OrgUsersUserUidTokensRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/users/me/settings': {
      id: '/$org/users/me/settings'
      path: '/settings'
      fullPath: '/$org/users/me/settings'
      preLoaderRoute: typeof OrgUsersMeSettingsRouteImport
      parentRoute: typeof OrgUsersMeRoute
    }
    '/admin/billing/invoices/': {
      id: '/admin/billing/invoices/'
      path: '/admin/billing/invoices'
      fullPath: '/admin/billing/invoices/'
      preLoaderRoute: typeof AdminBillingInvoicesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/billing/invoices/$uid': {
      id: '/admin/billing/invoices/$uid'
      path: '/admin/billing/invoices/$uid'
      fullPath: '/admin/billing/invoices/$uid'
      preLoaderRoute: typeof AdminBillingInvoicesUidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/u/$orgCode/$token/unsubscribe': {
      id: '/u/$orgCode/$token/unsubscribe'
      path: '/u/$orgCode/$token/unsubscribe'
      fullPath: '/u/$orgCode/$token/unsubscribe'
      preLoaderRoute: typeof UOrgCodeTokenUnsubscribeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/campaigns/$campaignUid/units/$unitUid': {
      id: '/$org/campaigns/$campaignUid/units/$unitUid'
      path: '/campaigns/$campaignUid/units/$unitUid'
      fullPath: '/$org/campaigns/$campaignUid/units/$unitUid'
      preLoaderRoute: typeof OrgCampaignsCampaignUidUnitsUnitUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/settings/members/$userUid/sessions': {
      id: '/$org/settings/members/$userUid/sessions'
      path: '/members/$userUid/sessions'
      fullPath: '/$org/settings/members/$userUid/sessions'
      preLoaderRoute: typeof OrgSettingsMembersUserUidSessionsRouteImport
      parentRoute: typeof OrgSettingsRoute
    }
    '/$org/types/sync/runs/': {
      id: '/$org/types/sync/runs/'
      path: '/types/sync/runs'
      fullPath: '/$org/types/sync/runs/'
      preLoaderRoute: typeof OrgTypesSyncRunsIndexRouteImport
      parentRoute: typeof OrgRoute
    }
    '/$org/types/sync/runs/$runUid': {
      id: '/$org/types/sync/runs/$runUid'
      path: '/types/sync/runs/$runUid'
      fullPath: '/$org/types/sync/runs/$runUid'
      preLoaderRoute: typeof OrgTypesSyncRunsRunUidRouteImport
      parentRoute: typeof OrgRoute
    }
    '/c/$orgCode/$token_/viewings/$viewingUid': {
      id: '/c/$orgCode/$token_/viewings/$viewingUid'
      path: '/c/$orgCode/$token/viewings/$viewingUid'
      fullPath: '/c/$orgCode/$token/viewings/$viewingUid'
      preLoaderRoute: typeof COrgCodeTokenViewingsViewingUidRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/$org/jobs/$jobUid/executions/$executionUid/': {
      id: '/$org/jobs/$jobUid/executions/$executionUid/'
      path: '/executions/$executionUid'
      fullPath: '/$org/jobs/$jobUid/executions/$executionUid/'
      preLoaderRoute: typeof OrgJobsJobUidExecutionsExecutionUidIndexRouteImport
      parentRoute: typeof OrgJobsJobUidRoute
    }
  }
}

interface OrgAssetsAssetUidRouteChildren {
  OrgAssetsAssetUidEditRoute: typeof OrgAssetsAssetUidEditRoute
}

const OrgAssetsAssetUidRouteChildren: OrgAssetsAssetUidRouteChildren = {
  OrgAssetsAssetUidEditRoute: OrgAssetsAssetUidEditRoute,
}

const OrgAssetsAssetUidRouteWithChildren =
  OrgAssetsAssetUidRoute._addFileChildren(OrgAssetsAssetUidRouteChildren)

interface OrgAssetsRouteChildren {
  OrgAssetsAssetUidRoute: typeof OrgAssetsAssetUidRouteWithChildren
  OrgAssetsAllRoute: typeof OrgAssetsAllRoute
  OrgAssetsCreateBasicRoute: typeof OrgAssetsCreateBasicRoute
  OrgAssetsOldRoute: typeof OrgAssetsOldRoute
  OrgAssetsIndexRoute: typeof OrgAssetsIndexRoute
  OrgAssetsAssetUidPlanEditorRoute: typeof OrgAssetsAssetUidPlanEditorRoute
}

const OrgAssetsRouteChildren: OrgAssetsRouteChildren = {
  OrgAssetsAssetUidRoute: OrgAssetsAssetUidRouteWithChildren,
  OrgAssetsAllRoute: OrgAssetsAllRoute,
  OrgAssetsCreateBasicRoute: OrgAssetsCreateBasicRoute,
  OrgAssetsOldRoute: OrgAssetsOldRoute,
  OrgAssetsIndexRoute: OrgAssetsIndexRoute,
  OrgAssetsAssetUidPlanEditorRoute: OrgAssetsAssetUidPlanEditorRoute,
}

const OrgAssetsRouteWithChildren = OrgAssetsRoute._addFileChildren(
  OrgAssetsRouteChildren,
)

interface OrgDocumentsRouteChildren {
  OrgDocumentsDocUidRoute: typeof OrgDocumentsDocUidRoute
  OrgDocumentsIndexRoute: typeof OrgDocumentsIndexRoute
}

const OrgDocumentsRouteChildren: OrgDocumentsRouteChildren = {
  OrgDocumentsDocUidRoute: OrgDocumentsDocUidRoute,
  OrgDocumentsIndexRoute: OrgDocumentsIndexRoute,
}

const OrgDocumentsRouteWithChildren = OrgDocumentsRoute._addFileChildren(
  OrgDocumentsRouteChildren,
)

interface OrgGroupRouteChildren {
  OrgGroupAccessRoute: typeof OrgGroupAccessRoute
  OrgGroupCriteriaRoute: typeof OrgGroupCriteriaRoute
  OrgGroupDefinitionsRoute: typeof OrgGroupDefinitionsRoute
  OrgGroupGovernanceRoute: typeof OrgGroupGovernanceRoute
  OrgGroupPerimetersRoute: typeof OrgGroupPerimetersRoute
  OrgGroupSitesRoute: typeof OrgGroupSitesRoute
  OrgGroupIndexRoute: typeof OrgGroupIndexRoute
}

const OrgGroupRouteChildren: OrgGroupRouteChildren = {
  OrgGroupAccessRoute: OrgGroupAccessRoute,
  OrgGroupCriteriaRoute: OrgGroupCriteriaRoute,
  OrgGroupDefinitionsRoute: OrgGroupDefinitionsRoute,
  OrgGroupGovernanceRoute: OrgGroupGovernanceRoute,
  OrgGroupPerimetersRoute: OrgGroupPerimetersRoute,
  OrgGroupSitesRoute: OrgGroupSitesRoute,
  OrgGroupIndexRoute: OrgGroupIndexRoute,
}

const OrgGroupRouteWithChildren = OrgGroupRoute._addFileChildren(
  OrgGroupRouteChildren,
)

interface OrgJobsJobUidRouteChildren {
  OrgJobsJobUidExecutionsExecutionUidIndexRoute: typeof OrgJobsJobUidExecutionsExecutionUidIndexRoute
}

const OrgJobsJobUidRouteChildren: OrgJobsJobUidRouteChildren = {
  OrgJobsJobUidExecutionsExecutionUidIndexRoute:
    OrgJobsJobUidExecutionsExecutionUidIndexRoute,
}

const OrgJobsJobUidRouteWithChildren = OrgJobsJobUidRoute._addFileChildren(
  OrgJobsJobUidRouteChildren,
)

interface OrgJobsRouteChildren {
  OrgJobsJobUidRoute: typeof OrgJobsJobUidRouteWithChildren
  OrgJobsBlockersRoute: typeof OrgJobsBlockersRoute
  OrgJobsIndexRoute: typeof OrgJobsIndexRoute
}

const OrgJobsRouteChildren: OrgJobsRouteChildren = {
  OrgJobsJobUidRoute: OrgJobsJobUidRouteWithChildren,
  OrgJobsBlockersRoute: OrgJobsBlockersRoute,
  OrgJobsIndexRoute: OrgJobsIndexRoute,
}

const OrgJobsRouteWithChildren =
  OrgJobsRoute._addFileChildren(OrgJobsRouteChildren)

interface OrgSettingsRouteChildren {
  OrgSettingsAiModelsRoute: typeof OrgSettingsAiModelsRoute
  OrgSettingsArchiveRoute: typeof OrgSettingsArchiveRoute
  OrgSettingsTagsTagIdRoute: typeof OrgSettingsTagsTagIdRoute
  OrgSettingsWebhooksSubscriptionUidRoute: typeof OrgSettingsWebhooksSubscriptionUidRoute
  OrgSettingsBillingIndexRoute: typeof OrgSettingsBillingIndexRoute
  OrgSettingsFeatureFlagsIndexRoute: typeof OrgSettingsFeatureFlagsIndexRoute
  OrgSettingsMembersIndexRoute: typeof OrgSettingsMembersIndexRoute
  OrgSettingsOrganizationIndexRoute: typeof OrgSettingsOrganizationIndexRoute
  OrgSettingsRolesIndexRoute: typeof OrgSettingsRolesIndexRoute
  OrgSettingsSecurityIndexRoute: typeof OrgSettingsSecurityIndexRoute
  OrgSettingsTagsIndexRoute: typeof OrgSettingsTagsIndexRoute
  OrgSettingsWebhooksIndexRoute: typeof OrgSettingsWebhooksIndexRoute
  OrgSettingsMembersUserUidSessionsRoute: typeof OrgSettingsMembersUserUidSessionsRoute
}

const OrgSettingsRouteChildren: OrgSettingsRouteChildren = {
  OrgSettingsAiModelsRoute: OrgSettingsAiModelsRoute,
  OrgSettingsArchiveRoute: OrgSettingsArchiveRoute,
  OrgSettingsTagsTagIdRoute: OrgSettingsTagsTagIdRoute,
  OrgSettingsWebhooksSubscriptionUidRoute:
    OrgSettingsWebhooksSubscriptionUidRoute,
  OrgSettingsBillingIndexRoute: OrgSettingsBillingIndexRoute,
  OrgSettingsFeatureFlagsIndexRoute: OrgSettingsFeatureFlagsIndexRoute,
  OrgSettingsMembersIndexRoute: OrgSettingsMembersIndexRoute,
  OrgSettingsOrganizationIndexRoute: OrgSettingsOrganizationIndexRoute,
  OrgSettingsRolesIndexRoute: OrgSettingsRolesIndexRoute,
  OrgSettingsSecurityIndexRoute: OrgSettingsSecurityIndexRoute,
  OrgSettingsTagsIndexRoute: OrgSettingsTagsIndexRoute,
  OrgSettingsWebhooksIndexRoute: OrgSettingsWebhooksIndexRoute,
  OrgSettingsMembersUserUidSessionsRoute:
    OrgSettingsMembersUserUidSessionsRoute,
}

const OrgSettingsRouteWithChildren = OrgSettingsRoute._addFileChildren(
  OrgSettingsRouteChildren,
)

interface OrgUserMeRouteChildren {
  OrgUserMeEmailIngestionRoute: typeof OrgUserMeEmailIngestionRoute
  OrgUserMeNotificationsRoute: typeof OrgUserMeNotificationsRoute
  OrgUserMePasskeysRoute: typeof OrgUserMePasskeysRoute
  OrgUserMePatRoute: typeof OrgUserMePatRoute
  OrgUserMeProfileRoute: typeof OrgUserMeProfileRoute
  OrgUserMeSecurityRoute: typeof OrgUserMeSecurityRoute
  OrgUserMeSessionsRoute: typeof OrgUserMeSessionsRoute
}

const OrgUserMeRouteChildren: OrgUserMeRouteChildren = {
  OrgUserMeEmailIngestionRoute: OrgUserMeEmailIngestionRoute,
  OrgUserMeNotificationsRoute: OrgUserMeNotificationsRoute,
  OrgUserMePasskeysRoute: OrgUserMePasskeysRoute,
  OrgUserMePatRoute: OrgUserMePatRoute,
  OrgUserMeProfileRoute: OrgUserMeProfileRoute,
  OrgUserMeSecurityRoute: OrgUserMeSecurityRoute,
  OrgUserMeSessionsRoute: OrgUserMeSessionsRoute,
}

const OrgUserMeRouteWithChildren = OrgUserMeRoute._addFileChildren(
  OrgUserMeRouteChildren,
)

interface OrgUserRouteChildren {
  OrgUserMeRoute: typeof OrgUserMeRouteWithChildren
}

const OrgUserRouteChildren: OrgUserRouteChildren = {
  OrgUserMeRoute: OrgUserMeRouteWithChildren,
}

const OrgUserRouteWithChildren =
  OrgUserRoute._addFileChildren(OrgUserRouteChildren)

interface OrgExpensesExpenseUidRouteChildren {
  OrgExpensesExpenseUidEditRoute: typeof OrgExpensesExpenseUidEditRoute
}

const OrgExpensesExpenseUidRouteChildren: OrgExpensesExpenseUidRouteChildren = {
  OrgExpensesExpenseUidEditRoute: OrgExpensesExpenseUidEditRoute,
}

const OrgExpensesExpenseUidRouteWithChildren =
  OrgExpensesExpenseUidRoute._addFileChildren(
    OrgExpensesExpenseUidRouteChildren,
  )

interface OrgInterventionsInterventionUidRouteChildren {
  OrgInterventionsInterventionUidEditRoute: typeof OrgInterventionsInterventionUidEditRoute
}

const OrgInterventionsInterventionUidRouteChildren: OrgInterventionsInterventionUidRouteChildren =
  {
    OrgInterventionsInterventionUidEditRoute:
      OrgInterventionsInterventionUidEditRoute,
  }

const OrgInterventionsInterventionUidRouteWithChildren =
  OrgInterventionsInterventionUidRoute._addFileChildren(
    OrgInterventionsInterventionUidRouteChildren,
  )

interface OrgIssuesUidRouteChildren {
  OrgIssuesUidEditRoute: typeof OrgIssuesUidEditRoute
}

const OrgIssuesUidRouteChildren: OrgIssuesUidRouteChildren = {
  OrgIssuesUidEditRoute: OrgIssuesUidEditRoute,
}

const OrgIssuesUidRouteWithChildren = OrgIssuesUidRoute._addFileChildren(
  OrgIssuesUidRouteChildren,
)

interface OrgUsersMeRouteChildren {
  OrgUsersMeSettingsRoute: typeof OrgUsersMeSettingsRoute
}

const OrgUsersMeRouteChildren: OrgUsersMeRouteChildren = {
  OrgUsersMeSettingsRoute: OrgUsersMeSettingsRoute,
}

const OrgUsersMeRouteWithChildren = OrgUsersMeRoute._addFileChildren(
  OrgUsersMeRouteChildren,
)

interface OrgRouteChildren {
  OrgActivityRoute: typeof OrgActivityRoute
  OrgAssetsRoute: typeof OrgAssetsRouteWithChildren
  OrgBenchmarkRoute: typeof OrgBenchmarkRoute
  OrgBusinessRulesRoute: typeof OrgBusinessRulesRoute
  OrgConversationsRoute: typeof OrgConversationsRoute
  OrgCreateBuildingRoute: typeof OrgCreateBuildingRoute
  OrgCreateBuildingGroupRoute: typeof OrgCreateBuildingGroupRoute
  OrgDataProtectionRoute: typeof OrgDataProtectionRoute
  OrgDebugRoute: typeof OrgDebugRoute
  OrgDesignReferenceRoute: typeof OrgDesignReferenceRoute
  OrgDocumentTypesRoute: typeof OrgDocumentTypesRoute
  OrgDocumentsRoute: typeof OrgDocumentsRouteWithChildren
  OrgGraphRoute: typeof OrgGraphRoute
  OrgGroupRoute: typeof OrgGroupRouteWithChildren
  OrgJobsRoute: typeof OrgJobsRouteWithChildren
  OrgKnowledgeRoute: typeof OrgKnowledgeRoute
  OrgLoginRoute: typeof OrgLoginRoute
  OrgPasswordResetRoute: typeof OrgPasswordResetRoute
  OrgPatternsRoute: typeof OrgPatternsRoute
  OrgPlanRenderingRoute: typeof OrgPlanRenderingRoute
  OrgReportsRoute: typeof OrgReportsRoute
  OrgSearchRoute: typeof OrgSearchRoute
  OrgSettingsRoute: typeof OrgSettingsRouteWithChildren
  OrgSignInLinkRoute: typeof OrgSignInLinkRoute
  OrgSteeringRoute: typeof OrgSteeringRoute
  OrgTestCrashRoute: typeof OrgTestCrashRoute
  OrgUserRoute: typeof OrgUserRouteWithChildren
  OrgIndexRoute: typeof OrgIndexRoute
  OrgAgentRunsRunUidRoute: typeof OrgAgentRunsRunUidRoute
  OrgAggregationsUidRoute: typeof OrgAggregationsUidRoute
  OrgAssembliesUidRoute: typeof OrgAssembliesUidRoute
  OrgAssetTypesAssetTypeUidRoute: typeof OrgAssetTypesAssetTypeUidRoute
  OrgCampaignsNewRoute: typeof OrgCampaignsNewRoute
  OrgCapexPlansPlanUidRoute: typeof OrgCapexPlansPlanUidRoute
  OrgComplianceControlsControlUidRoute: typeof OrgComplianceControlsControlUidRoute
  OrgComplianceControlsCreateRoute: typeof OrgComplianceControlsCreateRoute
  OrgComplianceRulesRuleUidRoute: typeof OrgComplianceRulesRuleUidRoute
  OrgComplianceRulesCreateRoute: typeof OrgComplianceRulesCreateRoute
  OrgContractStakeholderTypesContractStakeholderTypeUidRoute: typeof OrgContractStakeholderTypesContractStakeholderTypeUidRoute
  OrgContractStakeholderTypesCreateRoute: typeof OrgContractStakeholderTypesCreateRoute
  OrgContractTypesContractTypeUidRoute: typeof OrgContractTypesContractTypeUidRoute
  OrgContractTypesCreateRoute: typeof OrgContractTypesCreateRoute
  OrgContractsContractUidRoute: typeof OrgContractsContractUidRoute
  OrgContractsCreateRoute: typeof OrgContractsCreateRoute
  OrgContractsTimelineRoute: typeof OrgContractsTimelineRoute
  OrgConversationsIntakeAddressesRoute: typeof OrgConversationsIntakeAddressesRoute
  OrgDataExportRoute: typeof OrgDataExportRoute
  OrgDataImportRoute: typeof OrgDataImportRoute
  OrgDataQualityRoute: typeof OrgDataQualityRoute
  OrgDebugAnnotationsRoute: typeof OrgDebugAnnotationsRoute
  OrgDerivationsUidRoute: typeof OrgDerivationsUidRoute
  OrgExpensesExpenseUidRoute: typeof OrgExpensesExpenseUidRouteWithChildren
  OrgExpensesStatementRoute: typeof OrgExpensesStatementRoute
  OrgFolderLayoutsLayoutUidRoute: typeof OrgFolderLayoutsLayoutUidRoute
  OrgImportsImportUidRoute: typeof OrgImportsImportUidRoute
  OrgInterventionsInterventionUidRoute: typeof OrgInterventionsInterventionUidRouteWithChildren
  OrgIssuesUidRoute: typeof OrgIssuesUidRouteWithChildren
  OrgLabelsCodeRoute: typeof OrgLabelsCodeRoute
  OrgListingsListingUidRoute: typeof OrgListingsListingUidRoute
  OrgNormalizationsUidRoute: typeof OrgNormalizationsUidRoute
  OrgPropertiesCreateRoute: typeof OrgPropertiesCreateRoute
  OrgPropertyMappingRulesUidRoute: typeof OrgPropertyMappingRulesUidRoute
  OrgRelationTypesRelationTypeUidRoute: typeof OrgRelationTypesRelationTypeUidRoute
  OrgRelationTypesCreateRoute: typeof OrgRelationTypesCreateRoute
  OrgRemediationScenariosCodeRoute: typeof OrgRemediationScenariosCodeRoute
  OrgRentalApplicationsApplicationUidRoute: typeof OrgRentalApplicationsApplicationUidRoute
  OrgRentalApplicationsViewingsRoute: typeof OrgRentalApplicationsViewingsRoute
  OrgSignaturesUidRoute: typeof OrgSignaturesUidRoute
  OrgTagsTagCodeRoute: typeof OrgTagsTagCodeRoute
  OrgTypesDefaultsRoute: typeof OrgTypesDefaultsRoute
  OrgTypesExportRoute: typeof OrgTypesExportRoute
  OrgTypesImportRoute: typeof OrgTypesImportRoute
  OrgUsersCreateRoute: typeof OrgUsersCreateRoute
  OrgUsersMeRoute: typeof OrgUsersMeRouteWithChildren
  OrgAgentRunsIndexRoute: typeof OrgAgentRunsIndexRoute
  OrgAggregationsIndexRoute: typeof OrgAggregationsIndexRoute
  OrgAssembliesIndexRoute: typeof OrgAssembliesIndexRoute
  OrgAssetTypesIndexRoute: typeof OrgAssetTypesIndexRoute
  OrgCampaignsIndexRoute: typeof OrgCampaignsIndexRoute
  OrgCapexPlansIndexRoute: typeof OrgCapexPlansIndexRoute
  OrgComplianceControlsIndexRoute: typeof OrgComplianceControlsIndexRoute
  OrgComplianceRulesIndexRoute: typeof OrgComplianceRulesIndexRoute
  OrgContractStakeholderTypesIndexRoute: typeof OrgContractStakeholderTypesIndexRoute
  OrgContractTypesIndexRoute: typeof OrgContractTypesIndexRoute
  OrgContractsIndexRoute: typeof OrgContractsIndexRoute
  OrgDataIndexRoute: typeof OrgDataIndexRoute
  OrgDerivationsIndexRoute: typeof OrgDerivationsIndexRoute
  OrgExpensesIndexRoute: typeof OrgExpensesIndexRoute
  OrgFolderLayoutsIndexRoute: typeof OrgFolderLayoutsIndexRoute
  OrgImportsIndexRoute: typeof OrgImportsIndexRoute
  OrgInterventionsIndexRoute: typeof OrgInterventionsIndexRoute
  OrgIssuesIndexRoute: typeof OrgIssuesIndexRoute
  OrgLeasesIndexRoute: typeof OrgLeasesIndexRoute
  OrgListingsIndexRoute: typeof OrgListingsIndexRoute
  OrgNormalizationsIndexRoute: typeof OrgNormalizationsIndexRoute
  OrgPropertiesIndexRoute: typeof OrgPropertiesIndexRoute
  OrgPropertyMappingRulesIndexRoute: typeof OrgPropertyMappingRulesIndexRoute
  OrgRelationTypesIndexRoute: typeof OrgRelationTypesIndexRoute
  OrgRemediationScenariosIndexRoute: typeof OrgRemediationScenariosIndexRoute
  OrgRentalApplicationsIndexRoute: typeof OrgRentalApplicationsIndexRoute
  OrgSignaturesIndexRoute: typeof OrgSignaturesIndexRoute
  OrgTagsIndexRoute: typeof OrgTagsIndexRoute
  OrgTypesIndexRoute: typeof OrgTypesIndexRoute
  OrgUsersIndexRoute: typeof OrgUsersIndexRoute
  OrgAssembliesUidRoomRoute: typeof OrgAssembliesUidRoomRoute
  OrgCampaignsCampaignUidEditRoute: typeof OrgCampaignsCampaignUidEditRoute
  OrgPropertiesPropertyUidEditRoute: typeof OrgPropertiesPropertyUidEditRoute
  OrgTypesThematicsCodeRoute: typeof OrgTypesThematicsCodeRoute
  OrgUsersUserUidSettingsRoute: typeof OrgUsersUserUidSettingsRoute
  OrgUsersUserUidTokensRoute: typeof OrgUsersUserUidTokensRoute
  OrgCampaignsCampaignUidIndexRoute: typeof OrgCampaignsCampaignUidIndexRoute
  OrgPropertiesPropertyUidIndexRoute: typeof OrgPropertiesPropertyUidIndexRoute
  OrgTypesSyncIndexRoute: typeof OrgTypesSyncIndexRoute
  OrgTypesThematicsIndexRoute: typeof OrgTypesThematicsIndexRoute
  OrgUsersUserUidIndexRoute: typeof OrgUsersUserUidIndexRoute
  OrgCampaignsCampaignUidUnitsUnitUidRoute: typeof OrgCampaignsCampaignUidUnitsUnitUidRoute
  OrgTypesSyncRunsRunUidRoute: typeof OrgTypesSyncRunsRunUidRoute
  OrgTypesSyncRunsIndexRoute: typeof OrgTypesSyncRunsIndexRoute
}

const OrgRouteChildren: OrgRouteChildren = {
  OrgActivityRoute: OrgActivityRoute,
  OrgAssetsRoute: OrgAssetsRouteWithChildren,
  OrgBenchmarkRoute: OrgBenchmarkRoute,
  OrgBusinessRulesRoute: OrgBusinessRulesRoute,
  OrgConversationsRoute: OrgConversationsRoute,
  OrgCreateBuildingRoute: OrgCreateBuildingRoute,
  OrgCreateBuildingGroupRoute: OrgCreateBuildingGroupRoute,
  OrgDataProtectionRoute: OrgDataProtectionRoute,
  OrgDebugRoute: OrgDebugRoute,
  OrgDesignReferenceRoute: OrgDesignReferenceRoute,
  OrgDocumentTypesRoute: OrgDocumentTypesRoute,
  OrgDocumentsRoute: OrgDocumentsRouteWithChildren,
  OrgGraphRoute: OrgGraphRoute,
  OrgGroupRoute: OrgGroupRouteWithChildren,
  OrgJobsRoute: OrgJobsRouteWithChildren,
  OrgKnowledgeRoute: OrgKnowledgeRoute,
  OrgLoginRoute: OrgLoginRoute,
  OrgPasswordResetRoute: OrgPasswordResetRoute,
  OrgPatternsRoute: OrgPatternsRoute,
  OrgPlanRenderingRoute: OrgPlanRenderingRoute,
  OrgReportsRoute: OrgReportsRoute,
  OrgSearchRoute: OrgSearchRoute,
  OrgSettingsRoute: OrgSettingsRouteWithChildren,
  OrgSignInLinkRoute: OrgSignInLinkRoute,
  OrgSteeringRoute: OrgSteeringRoute,
  OrgTestCrashRoute: OrgTestCrashRoute,
  OrgUserRoute: OrgUserRouteWithChildren,
  OrgIndexRoute: OrgIndexRoute,
  OrgAgentRunsRunUidRoute: OrgAgentRunsRunUidRoute,
  OrgAggregationsUidRoute: OrgAggregationsUidRoute,
  OrgAssembliesUidRoute: OrgAssembliesUidRoute,
  OrgAssetTypesAssetTypeUidRoute: OrgAssetTypesAssetTypeUidRoute,
  OrgCampaignsNewRoute: OrgCampaignsNewRoute,
  OrgCapexPlansPlanUidRoute: OrgCapexPlansPlanUidRoute,
  OrgComplianceControlsControlUidRoute: OrgComplianceControlsControlUidRoute,
  OrgComplianceControlsCreateRoute: OrgComplianceControlsCreateRoute,
  OrgComplianceRulesRuleUidRoute: OrgComplianceRulesRuleUidRoute,
  OrgComplianceRulesCreateRoute: OrgComplianceRulesCreateRoute,
  OrgContractStakeholderTypesContractStakeholderTypeUidRoute:
    OrgContractStakeholderTypesContractStakeholderTypeUidRoute,
  OrgContractStakeholderTypesCreateRoute:
    OrgContractStakeholderTypesCreateRoute,
  OrgContractTypesContractTypeUidRoute: OrgContractTypesContractTypeUidRoute,
  OrgContractTypesCreateRoute: OrgContractTypesCreateRoute,
  OrgContractsContractUidRoute: OrgContractsContractUidRoute,
  OrgContractsCreateRoute: OrgContractsCreateRoute,
  OrgContractsTimelineRoute: OrgContractsTimelineRoute,
  OrgConversationsIntakeAddressesRoute: OrgConversationsIntakeAddressesRoute,
  OrgDataExportRoute: OrgDataExportRoute,
  OrgDataImportRoute: OrgDataImportRoute,
  OrgDataQualityRoute: OrgDataQualityRoute,
  OrgDebugAnnotationsRoute: OrgDebugAnnotationsRoute,
  OrgDerivationsUidRoute: OrgDerivationsUidRoute,
  OrgExpensesExpenseUidRoute: OrgExpensesExpenseUidRouteWithChildren,
  OrgExpensesStatementRoute: OrgExpensesStatementRoute,
  OrgFolderLayoutsLayoutUidRoute: OrgFolderLayoutsLayoutUidRoute,
  OrgImportsImportUidRoute: OrgImportsImportUidRoute,
  OrgInterventionsInterventionUidRoute:
    OrgInterventionsInterventionUidRouteWithChildren,
  OrgIssuesUidRoute: OrgIssuesUidRouteWithChildren,
  OrgLabelsCodeRoute: OrgLabelsCodeRoute,
  OrgListingsListingUidRoute: OrgListingsListingUidRoute,
  OrgNormalizationsUidRoute: OrgNormalizationsUidRoute,
  OrgPropertiesCreateRoute: OrgPropertiesCreateRoute,
  OrgPropertyMappingRulesUidRoute: OrgPropertyMappingRulesUidRoute,
  OrgRelationTypesRelationTypeUidRoute: OrgRelationTypesRelationTypeUidRoute,
  OrgRelationTypesCreateRoute: OrgRelationTypesCreateRoute,
  OrgRemediationScenariosCodeRoute: OrgRemediationScenariosCodeRoute,
  OrgRentalApplicationsApplicationUidRoute:
    OrgRentalApplicationsApplicationUidRoute,
  OrgRentalApplicationsViewingsRoute: OrgRentalApplicationsViewingsRoute,
  OrgSignaturesUidRoute: OrgSignaturesUidRoute,
  OrgTagsTagCodeRoute: OrgTagsTagCodeRoute,
  OrgTypesDefaultsRoute: OrgTypesDefaultsRoute,
  OrgTypesExportRoute: OrgTypesExportRoute,
  OrgTypesImportRoute: OrgTypesImportRoute,
  OrgUsersCreateRoute: OrgUsersCreateRoute,
  OrgUsersMeRoute: OrgUsersMeRouteWithChildren,
  OrgAgentRunsIndexRoute: OrgAgentRunsIndexRoute,
  OrgAggregationsIndexRoute: OrgAggregationsIndexRoute,
  OrgAssembliesIndexRoute: OrgAssembliesIndexRoute,
  OrgAssetTypesIndexRoute: OrgAssetTypesIndexRoute,
  OrgCampaignsIndexRoute: OrgCampaignsIndexRoute,
  OrgCapexPlansIndexRoute: OrgCapexPlansIndexRoute,
  OrgComplianceControlsIndexRoute: OrgComplianceControlsIndexRoute,
  OrgComplianceRulesIndexRoute: OrgComplianceRulesIndexRoute,
  OrgContractStakeholderTypesIndexRoute: OrgContractStakeholderTypesIndexRoute,
  OrgContractTypesIndexRoute: OrgContractTypesIndexRoute,
  OrgContractsIndexRoute: OrgContractsIndexRoute,
  OrgDataIndexRoute: OrgDataIndexRoute,
  OrgDerivationsIndexRoute: OrgDerivationsIndexRoute,
  OrgExpensesIndexRoute: OrgExpensesIndexRoute,
  OrgFolderLayoutsIndexRoute: OrgFolderLayoutsIndexRoute,
  OrgImportsIndexRoute: OrgImportsIndexRoute,
  OrgInterventionsIndexRoute: OrgInterventionsIndexRoute,
  OrgIssuesIndexRoute: OrgIssuesIndexRoute,
  OrgLeasesIndexRoute: OrgLeasesIndexRoute,
  OrgListingsIndexRoute: OrgListingsIndexRoute,
  OrgNormalizationsIndexRoute: OrgNormalizationsIndexRoute,
  OrgPropertiesIndexRoute: OrgPropertiesIndexRoute,
  OrgPropertyMappingRulesIndexRoute: OrgPropertyMappingRulesIndexRoute,
  OrgRelationTypesIndexRoute: OrgRelationTypesIndexRoute,
  OrgRemediationScenariosIndexRoute: OrgRemediationScenariosIndexRoute,
  OrgRentalApplicationsIndexRoute: OrgRentalApplicationsIndexRoute,
  OrgSignaturesIndexRoute: OrgSignaturesIndexRoute,
  OrgTagsIndexRoute: OrgTagsIndexRoute,
  OrgTypesIndexRoute: OrgTypesIndexRoute,
  OrgUsersIndexRoute: OrgUsersIndexRoute,
  OrgAssembliesUidRoomRoute: OrgAssembliesUidRoomRoute,
  OrgCampaignsCampaignUidEditRoute: OrgCampaignsCampaignUidEditRoute,
  OrgPropertiesPropertyUidEditRoute: OrgPropertiesPropertyUidEditRoute,
  OrgTypesThematicsCodeRoute: OrgTypesThematicsCodeRoute,
  OrgUsersUserUidSettingsRoute: OrgUsersUserUidSettingsRoute,
  OrgUsersUserUidTokensRoute: OrgUsersUserUidTokensRoute,
  OrgCampaignsCampaignUidIndexRoute: OrgCampaignsCampaignUidIndexRoute,
  OrgPropertiesPropertyUidIndexRoute: OrgPropertiesPropertyUidIndexRoute,
  OrgTypesSyncIndexRoute: OrgTypesSyncIndexRoute,
  OrgTypesThematicsIndexRoute: OrgTypesThematicsIndexRoute,
  OrgUsersUserUidIndexRoute: OrgUsersUserUidIndexRoute,
  OrgCampaignsCampaignUidUnitsUnitUidRoute:
    OrgCampaignsCampaignUidUnitsUnitUidRoute,
  OrgTypesSyncRunsRunUidRoute: OrgTypesSyncRunsRunUidRoute,
  OrgTypesSyncRunsIndexRoute: OrgTypesSyncRunsIndexRoute,
}

const OrgRouteWithChildren = OrgRoute._addFileChildren(OrgRouteChildren)

interface OrganizationsRouteChildren {
  OrganizationsOrgCodeRoute: typeof OrganizationsOrgCodeRoute
  OrganizationsIndexRoute: typeof OrganizationsIndexRoute
}

const OrganizationsRouteChildren: OrganizationsRouteChildren = {
  OrganizationsOrgCodeRoute: OrganizationsOrgCodeRoute,
  OrganizationsIndexRoute: OrganizationsIndexRoute,
}

const OrganizationsRouteWithChildren = OrganizationsRoute._addFileChildren(
  OrganizationsRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  OrgRoute: OrgRouteWithChildren,
  LoginRoute: LoginRoute,
  MfaSetupRoute: MfaSetupRoute,
  MfaVerifyRoute: MfaVerifyRoute,
  NoOrganizationRoute: NoOrganizationRoute,
  OrganizationsRoute: OrganizationsRouteWithChildren,
  AboutSlugRoute: AboutSlugRoute,
  AdminProposedRulesRoute: AdminProposedRulesRoute,
  AdminRentIndicesRoute: AdminRentIndicesRoute,
  ImpersonateTokenRoute: ImpersonateTokenRoute,
  InvitationsTokenRoute: InvitationsTokenRoute,
  QCodeRoute: QCodeRoute,
  SOrgCodeRoute: SOrgCodeRoute,
  TestSearcheableSelectRoute: TestSearcheableSelectRoute,
  VOrgCodeRoute: VOrgCodeRoute,
  AboutIndexRoute: AboutIndexRoute,
  AdminBillingOrgUidRoute: AdminBillingOrgUidRoute,
  AdminBillingPricesRoute: AdminBillingPricesRoute,
  AdminBillingSimulatorRoute: AdminBillingSimulatorRoute,
  COrgCodeTokenRoute: COrgCodeTokenRoute,
  ROrgCodeAddressRoute: ROrgCodeAddressRoute,
  TestBareCrashRoute: TestBareCrashRoute,
  WoOrgCodeTokenRoute: WoOrgCodeTokenRoute,
  AdminAgentPoolIndexRoute: AdminAgentPoolIndexRoute,
  AdminBillingIndexRoute: AdminBillingIndexRoute,
  AdminOrganizationsIndexRoute: AdminOrganizationsIndexRoute,
  AdminSettingsIndexRoute: AdminSettingsIndexRoute,
  AdminUsageIndexRoute: AdminUsageIndexRoute,
  AdminBillingInvoicesUidRoute: AdminBillingInvoicesUidRoute,
  UOrgCodeTokenUnsubscribeRoute: UOrgCodeTokenUnsubscribeRoute,
  AdminBillingInvoicesIndexRoute: AdminBillingInvoicesIndexRoute,
  COrgCodeTokenViewingsViewingUidRoute: COrgCodeTokenViewingsViewingUidRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
